<template>
  <div class="top_operation" @click="handleClaerActive">
    <div class="flex_item top-left-toolbar">
      <div v-if="pageType === 'listPage' || pageType === 'detailPage'" class="return_btn">
        <span>{{ subPageName }}</span>
      </div>
      <div
        class="control-button theme-color active"
        v-for="(item, index) in leftDataSource.children"
        :key="'control-button' + index"
      >
        <el-dropdown
          trigger="click"
          class="page-list-dropdown"
          @command="handleCommand"
          @visible-change="dropdownMenuVisible"
          v-if="pageType !== 'listPage' && pageType !== 'detailPage' && !isSubHeadPage"
        >
          <span class="el-dropdown-link flex" :class="menuShow ? 'menu-show':''">
            <span>{{ curPageName || "首页" }}</span>
            <i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="page-list scrollbar">
            <div class="dropdown-item-box">
              <el-dropdown-item
                class="overflowHid2"
                :key="index"
                v-for="(item, index) in pagelist"
                :class="pageId === item.publicId ? 'active' : ''"
                :command="index"
              >
                <i class="icon-portal-icon" v-if="index == 0"></i>{{ item.name }}
              </el-dropdown-item>
            </div>
            <router-link
              :to="{ path: '/homeList', query: { p: urlP, w: urlW, t: isOnlyPhonePageFlag } }"
              class="page-set fs14 baseTopColor"
              ><i class="icon-portal-mockup"></i>页面管理</router-link
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="top-name-box" v-if="showEditShape">
        <i class="icon-right icon-portal-arrows-right"></i>
        <span class="name"><i :class="getOptions.menuIconClass"></i>{{ getOptions.name }}</span>
      </div>
      <!-- 锁定图标 -->
      <el-tooltip
        v-if="lockingChecked"
        :open-delay="delayTime"
        effect="dark"
        content="编辑页已锁定，系统只会保存你提交的更改。如需解除锁定，请在顶部栏右侧更多菜单中操作。"
        placement="bottom"
        popper-class="width250"
      >
        <span class="icon-portal-locking col0004"></span>
      </el-tooltip>
    </div>
    <div class="flex_item device-item">
      <!--      暂时屏蔽，等功能完善后开放-->
      <el-tooltip
        v-if="!isOnlyPhonePageFlag && deviceType !== 2"
        :open-delay="delayTime"
        effect="dark"
        content="PC端"
        placement="bottom"
      >
        <span
          :class="[
            centerDataSource.children[0].isActive
              ? 'active control-button-device control-button'
              : 'control-button-device control-button'
          ]"
          class="icon-portal-computer2"
          @click="switchDevice(centerDataSource.children[0], 0)"
        ></span>
      </el-tooltip>
      <el-tooltip v-if="deviceType !== 1" :open-delay="delayTime" effect="dark" content="移动端" placement="bottom">
        <span
          :class="[
            centerDataSource.children[1].isActive
              ? 'active control-button-device control-button'
              : 'control-button-device control-button'
          ]"
          class="icon-portal-phone2"
          @click="switchDevice(centerDataSource.children[1], 1)"
        ></span>
      </el-tooltip>
    </div>
    <div class="flex_item content-r top-right-toolbar" id="rightToolbarWrap">
      <div class="flex_item" id="rightToolbarContent">
        <div v-if="!subPagePreview" class="flex_item handle-groups-wrap right-half-border">
          <!-- 显示在头部一行的模式-->
          <div class="flex_item handle-groups-first" style="display: none">
            <el-tooltip :open-delay="delayTime" effect="dark" content="同步数据" placement="bottom">
              <div class="control-button" v-if="request_prefix === 'appStage' && !isOnlyPhonePageFlag">
                <span class="icon icon-portal-refresh1" @click="syncBtnData"></span>
              </div>
            </el-tooltip>
            <el-tooltip :open-delay="delayTime" effect="dark" content="保存为模板" placement="bottom">
              <div
                v-show="pageType !== 'listPage' && pageType !== 'detailPage'"
                class="control-button"
                @click.stop="saveToTemplate"
              >
                <span class="icon icon-portal-page-template"></span>
              </div>
            </el-tooltip>
            <el-tooltip
              :open-delay="delayTime"
              effect="dark"
              content="收藏为模版"
              placement="bottom"
              v-show="pageType === 'listPage' || pageType === 'detailPage'"
            >
              <div class="control-button" @click.stop="setTemplatePage(true)">
                <span class="icon icon-portal-collection"></span>
              </div>
            </el-tooltip>
            <el-tooltip
              :open-delay="delayTime"
              effect="dark"
              :content="centerDataSource.children[0].isActive ? '保存为模板' : '保存为移动端系统模板'"
              placement="bottom"
              v-if="canUploadStyleToSystem"
            >
              <div
                v-show="pageType === 'listPage' || pageType === 'detailPage'"
                class="control-button"
                @click.stop="setTemplatePage(false)"
              >
                <span class="icon icon-portal-page-template"></span>
              </div>
            </el-tooltip>
            <el-tooltip
              :open-delay="delayTime"
              effect="dark"
              content="标记移动子页面样式"
              placement="bottom"
              v-if="managerType === 1"
            >
              <div
                v-show="(pageType === 'listPage' || pageType === 'detailPage') && centerDataSource.children[1].isActive"
                class="control-button"
                @click.stop="markMobileSubPageStyleToPc"
              >
                <span class="icon icon-portal-h5-mark"></span>
              </div>
            </el-tooltip>
            <!--            保留该功能，但是鉴于用户无法分辨，保存为登录模版之后差异很大，所以先注释，待后续产品出交互方案-->
            <el-tooltip
              :open-delay="delayTime"
              effect="dark"
              :content="`${isLoginPage ? '取消' : '保存为'}登录模板`"
              placement="bottom"
            >
              <div v-show="managerType === 1 && isAdmin" class="control-button" @click.stop="toLoginTemplate">
                <span class="icon icon-portal-login-template"></span>
              </div>
            </el-tooltip>
            <!--            目前太随意，所以先屏蔽，等产品出优化方案-->
            <el-tooltip :open-delay="delayTime" effect="dark" content="保存为H5模板" placement="bottom">
              <div
                v-show="
                  managerType === 1 &&
                  request_prefix === 'appStage' &&
                  pageType !== 'listPage' &&
                  pageType !== 'detailPage'
                "
                class="control-button"
                @click.stop="toH5Template"
              >
                <span class="icon icon-portal-h5-template"></span>
              </div>
            </el-tooltip>
            <el-tooltip :open-delay="delayTime" effect="dark" content="设置" placement="bottom">
              <div class="control-button" @click.stop="changeDialog">
                <span class="icon icon-portal-setting1"></span>
              </div>
            </el-tooltip>
          </div>
          <!-- 更多按钮展开 -->
          <el-popover
              placement="bottom-start"
              title=""
              width="180"
              trigger="hover"
              popper-class="control-button-more1">
            <el-button slot="reference" class="control-button control-button-more"><span class="more-handle-icon icon-portal-more"></span></el-button>
            <template>
              <!-- 展示不完--下拉模式-->
              <div class="pull-down-mode pull-down-lists handle-groups pull-down-lists1">
                <!-- 页面操作 -->
                <div
                    v-if="pageType !== 'listPage' && pageType !== 'detailPage'"
                    class="control-button pull-down-list"
                    @click.stop="saveToTemplate"
                >
                  <span class="icon icon-portal-page-template"></span>
                  <p class="keep-all">保存为模板</p>
                </div>
                <!--              目前太随意，所以先屏蔽，等产品出优化方案-->
                <div
                    v-if="request_prefix === 'appStage' && pageType !== 'listPage' && pageType !== 'detailPage'"
                    class="control-button pull-down-list"
                    @click.stop="toH5Template"
                >
                  <span class="icon icon-portal-h5-template"></span>
                  <p class="keep-all">保存为H5网站模板</p>
                </div>
                <div
                    v-if="pageType === 'listPage' || pageType === 'detailPage'"
                    class="control-button pull-down-list"
                    @click.stop="setTemplatePage(true)"
                >
                  <span class="icon icon-portal-collection"></span>
                  <p class="keep-all" v-if="pageType === 'listPage'">保存为列表页模板</p>
                  <p class="keep-all" v-else>保存为详情页模板</p>
                </div>
                <div
                    v-if="(pageType === 'listPage' || pageType === 'detailPage') && canUploadStyleToSystem"
                    class="control-button pull-down-list"
                    @click.stop="setTemplatePage(false)"
                >
                  <span class="icon icon-portal-page-template"></span>
                  <p class="keep-all">保存为系统模板</p>
                </div>
                <div
                    v-if="
                  (pageType === 'listPage' || pageType === 'detailPage') &&
                  centerDataSource.children[1].isActive &&
                  managerType === 1
                "
                    class="control-button pull-down-list"
                    @click.stop="markMobileSubPageStyleToPc"
                >
                  <span class="icon icon-portal-h5-mark"></span>
                  <p class="keep-all">标记移动子页面样式</p>
                </div>
                <div
                    class="control-button pull-down-list"
                    v-if="request_prefix === 'appStage' && !isOnlyPhonePageFlag"
                    @click="syncBtnData"
                >
                  <span class="icon icon-portal-refresh1"></span>
                  <p class="keep-all">从电脑端同步页面</p>
                </div>
                <!-- 管理功能 -->
                <div class="item-manage" style="display: none">
                  <div class="control-button pull-down-list" @click.stop="lockingFunc">
                    <template v-if="lockingChecked">
                      <span class="icon icon-portal-unlock"></span>
                      <p class="keep-all">解锁页面</p>
                    </template>
                    <template v-else>
                      <span class="icon icon-portal-lock"></span>
                      <p class="keep-all">锁定页面</p>
                    </template>
                  </div>
                </div>
                <!-- ​其他入口 -->
                <div class="control-button pull-down-list" @click="toAdmin">
                  <span class="icon icon-portal-manage-data"></span>
                  <p class="keep-all">管理后台</p>
                </div>
                <div class="control-button pull-down-list" @click.stop="setDialogShow = true">
                  <span class="icon icon-portal-setting1"></span>
                  <p class="keep-all">更多设置</p>
                </div>
              </div>
            </template>
          </el-popover>
          <div class="flex_item handle-groups-second">
            <el-tooltip v-if="canGoBack" :open-delay="delayTime" effect="dark" :content="repealStr + ' ( ' + ctrlKey +' Z )'" placement="bottom">
              <div class="control-button left-cutting-line" @click.stop="goBackHandel">
                <span class="icon icon-portal-return"></span>
              </div>
            </el-tooltip>
            <div v-else class="control-button left-cutting-line disabled" @click.stop>
              <span class="icon icon-portal-return"></span>
            </div>
            <el-tooltip v-if="canGoNext" :open-delay="delayTime" effect="dark" :content="recoverStr + ' ( ' + ctrlKey + ' ' + shiftKey +' Z )'" placement="bottom">
              <div class="control-button" @click.stop="goNextHandel">
                <span class="icon icon-portal-go-on"></span>
              </div>
            </el-tooltip>
            <div v-else class="control-button disabled" @click.stop>
              <span class="icon icon-portal-go-on"></span>
            </div>
          </div>
          <!-- 放大缩小 -->
          <div v-if="!subPagePreview" class="zoom-box">
            <el-popover
              placement="bottom"
              title=""
              width="200"
              trigger="manual"
              popper-class="zoom-box-pop"
              ref="zoomBoxPopover"
              @show="zoomPopShowFunc"
              @hide="zoomPopHideFunc"
              v-model="zoomPopShow"
            >
              <el-button slot="reference" class="zoom-pop-btn" :class="zoomPopShow ? 'zoom-pop-show' : ''" @click="togglePopover">
                <el-tooltip
                  :open-delay="delayTime"
                  class="item"
                  effect="dark"
                  content="缩放/显示选项"
                  placement="bottom"
                >
                  <div>
                    <div class="zoom-val">{{ `${zoomVal}%` }}</div>
                    <i class="icon-portal-arrows-down" :class="zoomPopShow ? 'rotate180' : ''"></i>
                  </div>
                </el-tooltip>
              </el-button>
              <div ref="zoomBoxPopover1">
                <single-input ref="elZoomInput" :value.sync="zoomVal" :max="200" inputSuffixs="%" />
                <ul class="zoom-lists fs13 borderT1">
                  <li
                    v-for="(item, index) in selectZoomOptions"
                    :key="item.label + '_' + index"
                    @click.stop="selectZoomFunc(item, index)"
                  >
                    <div class="list-icon floatLeft">
                      <i v-if="index > 1 && zoomVal == item.value" class="icon-portal-check floatLeft"></i>
                    </div>
                    <span class="list-label floatLeft">{{ item.label }}</span>
                    <span class="fs13 right-key floatRight" v-if="item.key">
                      <template v-if="item.value === 'bigger'">{{ ctrlKey }} +</template>
                      <template v-else-if="item.value === 'smaller'">{{ ctrlKey }} -</template>
                      <template v-else-if="item.value === '100'">{{ shiftKey }} 0</template>
                    </span>
                  </li>
                  <hr class="zoom-lists-line">
                  <li @click.stop="topOperationSetting1(4)" class="">
                    <div class="list-icon floatLeft">
                      <i v-if="!showAllScreen" class="icon-portal-check floatLeft"></i>
                    </div>
                    <span class="list-label floatLeft">适应屏幕宽度</span>
                  </li>
<!--                  暂时注释-->
<!--                  <li @click.stop="topOperationSetting1(1)">-->
<!--                    <div class="list-icon floatLeft">-->
<!--                      <i v-if="showAllComponent" class="icon-portal-check floatLeft"></i>-->
<!--                    </div>-->
<!--                    <span class="list-label floatLeft">显示全部组件</span>-->
<!--                  </li>-->
                  <li @click.stop="topOperationSetting1(2)">
                    <div class="list-icon floatLeft">
                      <i v-if="showComponentName" class="icon-portal-check floatLeft"></i>
                    </div>
                    <span class="list-label floatLeft">显示组件名称</span>
                  </li>
                  <li @click.stop="topOperationSetting1(3)">
                    <div class="list-icon floatLeft"><i v-if="showRuler" class="icon-portal-check floatLeft"></i></div>
                    <span class="list-label floatLeft">显示标尺</span>
                  </li>
                </ul>
              </div>
            </el-popover>
          </div>
          <div class="flex_item handle-groups-second ml0">
            <div class="control-button width82" @click.stop="pageSetClick()">页面设置</div>
          </div>
        </div>
        <div class="flex_item previewSave">
          <div
            v-if="(pageType === 'listPage' || pageType === 'detailPage') && !subPagePreview"
            class="control-button"
            @click.stop="saveSubPageTemplate"
          >
            <el-button class="preview">
              <span>切换模板</span>
            </el-button>
          </div>
          <div v-if="!subPagePreview" class="control-button" @click.stop="judgePreviewHandle">
            <el-button :disabled="isPreviewStatus || (isSaveStatus && !previewResolve)"  :class="isPreviewStatus || (isSaveStatus && !previewResolve) ? 'preview previewBtn is_disabled' : 'preview previewBtn'">
              <span><span v-if="isPreviewStatus" class="icon icon-portal-loading1"></span>预览</span>
            </el-button>
          </div>
          <div v-if="subPagePreview" class="control-button" @click.stop="editSubpage">
            <el-button :class="[isEditStatus ? 'preview is_disabled ' : 'preview', 'edit']">
              <span v-if="isEditStatus" class="icon icon-portal-loading1"></span>
              <i v-if="!isEditStatus" class="icon-portal-edit"></i>
              <span>编辑{{ pageType === "listPage" ? "列表页" : "详情页" }}</span>
            </el-button>
          </div>
          <div v-show="!subPagePreview" id="savePage" class="control-button" @click.stop="judgeSaveHandle" >
            <el-button :disabled="isSaveStatus || isPreviewStatus" :class="isSaveStatus || isPreviewStatus ? 'save is_disabled' : 'save'" >
              <span v-if="!isSaveStatus || previewResolve">保存</span>
              <span v-if="isSaveStatus && !previewResolve"><span class="icon icon-portal-loading1"></span>保存中</span>
            </el-button>
          </div>
          <div v-if="subPagePreview" class="control-button"  @click.stop="judgeSaveSubPage">
            <el-button :disabled="isSaveStatus || isPreviewStatus" :class="isSaveStatus || isPreviewStatus ? 'save is_disabled' : 'save'" >
              <span v-if="!isSaveStatus">保存</span>
              <span v-if="isSaveStatus"><span class="icon icon-portal-loading1"></span>保存中</span>
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 子页面设为模版页对话框 -->
    <add-page-template-dialog
      :dialogFormVisible="setTemplatePageDialog"
      :type="pageType"
      :isCollect="isCollect"
      @closeDialog="setTemplatePageDialog = false"
    ></add-page-template-dialog>

    <!-- 设为模板对话框 -->
    <el-dialog
      :title="H5TemplateSaving ? 'H5模板名称' : '模板名称'"
      :modal-append-to-body="false"
      :append-to-body="setTempLateDialogAppendToBody"
      :visible.sync="setTempLateDialog"
      width="30%"
    >
      <el-form :model="form" label-width="80px">
        <el-form-item label="模板名称">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
      </el-form>
      <div class="textCenter" style="margin-top: 16px">
        <el-button @click="setTempLateDialog = false">取 消</el-button>
        <el-button type="primary" @click="postTemplateData">保 存</el-button>
      </div>
    </el-dialog>

    <!-- 设置弹窗 -->
    <el-dialog
      title="设置"
      :modal="false"
      :append-to-body="true"
      :visible.sync="setDialogShow"
      custom-class="setDialog"
    >
      <div class="left-menu">
        <a
          class="menu-btn"
          :class="pointIndex == index ? 'active' : ''"
          v-for="(item, index) in leftMenuList"
          :key="index"
          @click="pointClick(item.id, index)"
          >{{ item.name }}</a
        >
      </div>
      <div class="right-content">
        <div id="baisc" class="basic-set" style="display: none">
          <div>
            <!-- <el-button class="mr12" @click="changeMangerType" :key="managerType">{{
              managerType === 1 ? "切换到普通版" : "切换到专业版"
            }}</el-button> -->
            <el-button class="backstage" @click="toAdmin">进入后台</el-button>
          </div>
          <div class="form-item">
            <p class="label">权限设置</p>
            <el-checkbox v-model="lockingChecked" class="locking">锁定门户</el-checkbox>
            <p class="tips">锁定后，该页面将不能被其他管理员编辑，系统只会保存您提交的更改</p>
          </div>
          <div class="form-item">
            <p class="label">显示设置</p>
            <el-checkbox label="显示标尺" v-model="showRuler" @change="setToolCheckList('ruler')"></el-checkbox>
            <el-checkbox
              label="显示页面缩放按钮"
              v-model="showAllScreen"
              @change="setToolCheckList('width')"
            ></el-checkbox>
            <el-checkbox
              label="显示组件名称"
              v-model="showComponentName"
              @change="setToolCheckList('comptName')"
            ></el-checkbox>
<!--            <el-checkbox-->
<!--              label="显示全部组件"-->
<!--              v-model="showAllComponent"-->
<!--              @change="setToolCheckList('professional')"-->
<!--            ></el-checkbox>-->
            <el-checkbox
              label="显示图层"
              v-if="isPhoneFullScreen"
              v-model="showPhoneLayer"
              @change="setToolCheckList('showPhoneLayer')"
            ></el-checkbox>
          </div>
        </div>
        <div id="theme">
          <div class="form-item">
            <p class="label">主题设置</p>
            <el-radio-group v-model="editPageThemeColor" class="theme-box">
              <div class="theme-item" v-for="(item, index) in themeList" :key="index" @click="changeStyleColor(index)">
                <div class="img-box"><img :src="item.src" alt="" /></div>
                <p class="radio-box">
                  <el-radio :label="index">{{ item.name }}</el-radio>
                </p>
              </div>
            </el-radio-group>
          </div>
        </div>
        <div id="key">
          <div class="form-item">
            <p class="label">快捷键</p>
            <ul class="shortcut-list">
              <li>
                <p class="left">撤销</p>
                <div class="right-key">
                  <p class="key">{{ ctrlKey }}</p>
                  <p class="key">Z</p>
                </div>
              </li>
              <li>
                <p class="left">恢复</p>
                <div class="right-key">
                  <p class="key">{{ ctrlKey }}</p>
                  <p class="key">{{ shiftKey }}</p>
                  <p class="key">Z</p>
                </div>
              </li>
              <li>
                <p class="left">复制</p>
                <div class="right-key">
                  <p class="key">{{ ctrlKey }}</p>
                  <p class="key">C</p>
                </div>
              </li>
              <li>
                <p class="left">编组</p>
                <div class="right-key">
                  <p class="key">{{ ctrlKey }}</p>
                  <p class="key">G</p>
                </div>
              </li>
              <li>
                <p class="left">粘贴</p>
                <div class="right-key">
                  <p class="key">{{ ctrlKey }}</p>
                  <p class="key">V</p>
                </div>
              </li>
              <li>
                <p class="left">取消编组</p>
                <div class="right-key">
                  <p class="key">{{ ctrlKey }}</p>
                  <p class="key">{{ shiftKey }}</p>
                  <p class="key">G</p>
                </div>
              </li>
              <li>
                <p class="left">多选</p>
                <div class="right-key">
                  <p class="key">{{ shiftKey }}</p>
                  <p class="key">单击</p>
                </div>
              </li>
              <li>
                <p class="left">删除</p>
                <div class="right-key">
                  <p class="key">Backspace/Delete</p>
                </div>
              </li>
              <li>
                <p class="left">放大</p>
                <div class="right-key">
                  <p class="key">{{ ctrlKey }}</p>
                  <p class="key">+</p>
                </div>
              </li>
              <li>
                <p class="left">缩小</p>
                <div class="right-key">
                  <p class="key">{{ ctrlKey }}</p>
                  <p class="key">-</p>
                </div>
              </li>
              <li>
                <p class="left">缩放至100%</p>
                <div class="right-key">
                  <p class="key">{{ shiftKey }}</p>
                  <p class="key">0</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div id="advanced" class="advanced-set" v-if="pageType !== 'listPage' && pageType !== 'detailPage'">
          <div class="form-item">
            <p class="label">高级功能</p>
            <el-button type="danger" plain size="small" class="mt12" @click="clearAllRect"> 清空页面内容 </el-button>
            <span class="clear-tip">清空内容后，页面内的所有组件将会消失</span>
            <el-checkbox v-if="request_prefix === 'stage'" label="开启网站缩放" v-model="isPageScale"></el-checkbox>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
* {
  margin: 0;
}
.handle-groups-wrap .control-button.icon-portal-refresh1 {
  font-size: 18px;
  margin-top: 2px;
}
.return_btn {
  font-size: 15px;
  color: rgba(0, 0, 0, 0.8);
}

.keep-all {
  word-break: keep-all;
}
.icon-portal-clear:before {
  color: inherit;
}
.mouseover::before {
  color: var(--themeColor);
}
.top_operation {
  width: 100%;
  min-width: 1180px;
  height: 50px;
  display: flex;
  padding: 0 16px;
  box-sizing: border-box;
  justify-content: space-between;
  position: fixed;
  top: 0;
  background: var(--topOperationBgColor);
  z-index: 1000;
  // border-bottom: 1px solid #ececec;
  text-align: center;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.07);
  .top-left-toolbar,
  .top-right-toolbar {
    width: calc(50% - 160px);
    //flex: 1;
  }
  .device-item {
    //width: 20%;
    width: 100px;
  }
}

.flex_item {
  display: flex;
  align-items: center;
}

.page_handle_btns .control-button {
  min-width: 36px;
  height: 36px;
  padding: 6px;
  text-align: center;
  border-radius: 8px;
  margin: 0 4px;
  &:hover {
    background: rgba(255, 255, 255, 0.12);
  }
}
.top-left-toolbar {
  line-height: 50px;
}
.control-button.hide {
  display: none !important;
}
.device-item .control-button {
  //border-right: 1px solid #e2e2e2;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  min-width: 50px;
  color: var(--topOperationIconColor);
  padding: 0;

  &.active {
    background-color: var(--topOperationIconBgColor);
    color: var(--elTreeActiveColor);
    &::after {
      content: "";
      position: absolute;
      display: block;
      bottom: 0;
      width: 100%;
      height: 2px;
      background-color: var(--elTreeActiveColor);
    }
  }

  &:not(.active):hover {
    color: var(--topOperationAColor);
  }
}

.left-cutting-line::before {
  position: absolute;
  content: "";
  top: 50%;
  left: -20px;
  transform: translateY(-50%);
  height: 20px;
  width: 1px;
  background-color: var(--topOperationBorderColor);
}
.el-button.mr12 {
  margin-right: 12px;
}
.el-button.mt12 {
  margin-top: 12px;
}
.control-button {
  position: relative;
  min-width: 34px;
  padding: 0 16px 0 0;
  cursor: pointer;
  font-size: 14px;
  color: var(--topOperationColor);
  line-height: 21px;
  .icon {
    font-size: 22px;
    &:before {
      color: var(--topOperationColor);
    }
  }
  .preview {
    width: 80px;
    height: 32px;
    padding: 0;
    line-height: 20px;
    background: transparent;
    color: var(--topOperationAColor);
    border: 1px solid var(--topOperationAColor);
    font-weight: 400;

    &:hover {
      background: var(--previewButtonHover);
    }
    &.is_disabled {
      background: var(--defaultButtonHover);
    }
    .icon-portal-loading1 {
      display: inline-block;
      margin-right: 4px;
      transform: rotate(90deg);
      font-size: 14px;
      color: var(--topOperationAColor);
      vertical-align: middle;
      margin-top: -2px;
      animation: rotation 1s linear infinite;
      &:before {
        color: var(--topOperationAColor);
      }
    }
    &.edit {
      width: 110px;
      .icon-portal-edit {
        font-size: 16px;
        margin-right: 2px;
        padding-bottom: 3px;
        display: inline-block;
        vertical-align: middle;
      }
      .icon-portal-edit:before {
        color: var(--topOperationAColor);
      }
    }
  }

  .save {
    width: 80px;
    padding: 0;
    height: 32px;
    line-height: 20px;
    background-color: var(--topOperationAColor);
    border: 0;
    color: var(--topOperationSaveColor);
    font-weight: 400;
    &:hover {
      background: var(--primaryButtonHover);
    }
    &.is_disabled {
      background: var(--primaryButtonHover);
    }
    .icon-portal-loading1 {
      display: inline-block;
      margin-right: 4px;
      transform: rotate(90deg);
      font-size: 14px;
      color: var(--topOperationSaveColor);
      vertical-align: middle;
      margin-top: -2px;
      animation: rotation 1s linear infinite;
      &:before {
        color: var(--topOperationSaveColor);
      }
    }
  }

  .down-icon {
    position: absolute;
    right: 2px;
    top: 5px;
    transform: rotate(90deg);
  }
}
@keyframes rotation {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}

.control-button-device svg {
  fill: #3899ec;
  height: auto;
  width: 24px;
}

.control-button.active {
  color: var(--themeColor);
}

.control-button.unactive {
  color: #ccc;
}

.pages {
  position: relative;
  z-index: 9997;
}

.select-list {
  position: absolute;
  //display: none;
  top: 60px;
  left: 10px;
  width: 300px;
  max-height: 400px;
  text-align: left;
  background: rgba(255, 255, 255, 1);
  z-index: 2;
  overflow-y: auto;
  background: #ffffff;
  /* shadow_2 */
  box-shadow: 0px 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 9px 28px rgba(0, 0, 0, 0.05),
    0px 12px 48px 16px rgba(0, 0, 0, 0.03);
  border-radius: 8px;

  .select-list-title {
    position: relative;
    line-height: 48px;
    background: #3d82f2;
    font-size: 14px;
    color: #fff;
    padding: 0 20px;
    box-sizing: border-box;

    .icon-portal-close-small {
      position: absolute;
      top: 15px;
      right: 20px;
      z-index: 2;
      cursor: pointer;
    }
  }

  .select-list-ul {
    max-height: 300px;

    > li {
      line-height: 20px;
      padding: 15px 20px;
      color: rgba(0, 0, 0, 0.6);

      &:hover {
        color: var(--themeColor);
      }

      &.active {
        color: var(--themeColor);
        background: #e8f0fd;
        position: relative;

        &::before {
          position: absolute;
          right: 20px;
          top: 50%;
          margin-top: -8px;
        }
      }
    }
  }
}

.add-page-btn {
  padding: 16px;
  box-sizing: border-box;
  cursor: pointer;

  .icon {
    margin-right: 4px;
  }
}
.handle-groups-wrap {
  position: relative;
  .control-button {
    min-width: 34px;
    height: 34px;
    padding: 6px;
    border-radius: 8px;
    margin: 0 4px;
    &:not(.disabled):hover {
      background: var(--topControlHoverBg);
    }
  }
}

.handle-groups-first .control-button:last-child {
  margin-right: 16px;
}

@media screen and (max-width: 1200px) {
  .handle-groups-first {
    display: none;
  }
}

.handle-groups-second {
  position: relative;
  margin-left: 16px;
  &.ml0 {
    margin-left: 0;
  }
  .control-button.disabled {
    cursor: not-allowed;
    .icon::before {
      color: var(--topIconDisabled);
    }
  }
}
.handle-groups-wrap {
  margin: 0 16px 0 0;
  &:after {
    position: absolute;
    right: -16px;
    top: 50%;
    transform: translateY(-50%);
    height: 20px;
    width: 1px;
    content: "";
    background-color: var(--topOperationBorderColor);
  }
}
::v-deep .zoom-box {
  position: relative;
  /*margin: 0 16px;*/
  width: 80px;
  line-height: 34px;
  &::before {
    /*position: absolute;*/
    content: "";
    top: 50%;
    left: -16px;
    transform: translateY(-50%);
    height: 20px;
    width: 1px;
    background-color: var(--topOperationBorderColor);
  }
  .el-select {
    margin: 8px 0;
    width: 100%;
    .el-input__inner {
      background-color: transparent;
      color: var(--textColor);
      border-radius: 8px;
      text-align: center;
      padding: 8px 5px;
      font-size: 13px;
      width: 72px;
      height: 34px;
      line-height: 34px;
      vertical-align: top;
      &:focus {
        box-shadow: none;
      }
    }
    .el-input .el-select__caret {
      font-size: 12px;
      /*display: none;*/
      color: var(--textColor);
    }
    .el-input .el-input__inner:focus {
      border: none !important;
    }
    .el-input.is-focus .el-input__inner {
      border: none;
      background: var(--topControlHoverBg);
    }
    .el-input .el-input__inner:hover {
      background: var(--topControlHoverBg);
    }
    .el-select-dropdown {
      width: 200px !important;
      margin-top: 7px;
      transform: translateX(-124px);
    }
    .el-select-dropdown .el-scrollbar__wrap {
      // width: 100%;
      margin-right: 0 !important;
      width: calc(100% + 20px);
      overflow-x: hidden;
      max-height: unset;
      .right-key {
        color: var(--thirdTextColor);
      }
      .el-select-group__wrap:not(:last-of-type) {
        padding-bottom: 8px;
        padding-top: 4px;
        &::after {
          left: 0;
          right: 0;
          bottom: 4px;
        }
      }
    }
    .el-select-dropdown__list {
      box-shadow: 0px 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 8px 20px rgba(0, 0, 0, 0.12);
      border-radius: 4px;
      border: 1px solid #e9e9e9;
      background: #ffffff !important;
      text-align: left;
    }
    .el-select-dropdown .el-input {
      margin-left: 12px;
      margin-bottom: 8px;
      /*width: 90px;*/
      /*height: 32px;*/
      line-height: 32px;
      width: calc(100% - 24px);
      &::after {
        position: absolute;
        bottom: -8px;
        left: -12px;
        content: "";
        display: block;
        height: 1px;
        width: calc(100% + 24px);
        background: rgba(0, 0, 0, 0.07);
      }
      .el-input-group__append {
        top: 4px;
      }
    }
    .el-select-dropdown .el-input__inner {
      background: #f3f3f3;
      border-radius: 4px;
      color: rgba(0, 0, 0, 0.8);
      text-align: left;
      box-sizing: border-box;
      font-size: 14px;
      width: 100%;
      padding: 5px 5px 5px 12px;
      height: 32px;
      line-height: 22px;
      &:hover {
        background: #f3f3f3;
      }
      &:focus {
        box-shadow: inset 0px 0px 0px 2px var(--themeColor);
      }
    }
    .el-select-dropdown .el-input .el-input__suffix {
      color: rgba(0, 0, 0, 0.6);
    }
    .el-scrollbar__bar {
      width: 0;
      height: 0;
    }
  }
  .zoomIcon {
    position: absolute;
    z-index: 10;
    top: 50%;
    transform: translateY(-50%);
    color: var(--topThirdTextColor);
    font-size: 18px;
    cursor: pointer;
    width: 22px;
    height: 34px;
    line-height: 34px;
    text-align: center;
    border-radius: 8px;
    &:hover {
      color: var(--topSubTextColor);
      background: var(--topControlHoverBg);
    }
    &.icon-portal-zoom-out {
      left: 4px;
    }
    &.icon-portal-zoom-in {
      right: 4px;
    }
  }
  .el-popover__reference-wrapper {
    .el-button--default {
      border: 0;
      width: 72px;
      /*padding: 0 12px;*/
      padding: 0 8px 0 0;
      color: var(--topOperationColor);
      height: 34px;
      line-height: 34px;
      background-color: transparent;
      &.zoom-pop-show {
        background-color: var(--topControlHoverBg);
      }
      .el-tooltip {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .rotate180 {
          transform: rotate(180deg);
        }
      }
    }
  }
  .zoom-pop-btn:hover{
    background-color: var(--topControlHoverBg);
    .item i{
      margin-top: 4px;
    }
  }
}
.handle-groups {
  display: flex;
}
.handle-groups.pull-down-mode {
  display: inline-block;
  top: 34px;
  left: 0;
}
.top-right-toolbar .pull-down-lists,
.control-button-more1 .pull-down-lists{
  position: absolute;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  box-sizing: border-box;
  box-shadow: 0 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 9px 28px rgba(0, 0, 0, 0.05),
    0px 12px 48px 16px rgba(0, 0, 0, 0.03);
  border-radius: 4px;
  padding: 4px 0;
  width: 180px;
  &.pull-down-lists1{
    position: relative;
    top: 4px;
  }
  .pull-down-list:hover {
    background-color: #f0f2f7;
  }
  .pull-down-list {
    position: relative;
    padding: 10px 12px;
    text-align: left;
    color: rgba(0, 0, 0, 0.8);
    height: auto;
    border-radius: 0;
    margin: 0;
    .icon {
      display: inline-block;
      vertical-align: middle;
      margin-right: 8px;
      font-size: 16px;
      &:before {
        color: rgba(0, 0, 0, 0.8);
        // color: var(--themeColor);
      }
    }
    p {
      display: inline-block;
      vertical-align: middle;
    }
    .selected-icon {
      display: inline-block;
      width: 12px;
      margin-right: 10px;
      color: var(--themeColor);
    }
  }
  .item-manage {
    border-top: 1px solid #f0f0f0;
    border-bottom: 1px solid #f0f0f0;
  }
}
.pull-down-lists-h {
  top: 0;
  width: 142px;
  right: -142px;
}
.more-handle-icon {
  display: inline-block;
  transform: rotate(90deg);
  cursor: pointer;
  font-size: 22px;
}
.handle-groups-wrap .control-button.control-button-more {
  position: relative;
  min-width: auto;
  margin-right: 16px;
  background-color: transparent;
  border: 0;
}
::v-deep .qrcodeDialog {
  width: 360px;
}
::v-deep .qrcodeDialog .el-dialog__body {
  border: none;
  padding: 40px;
}
#qrcode {
  display: inline-block;
}
.theme-color {
  line-height: 42px;
}
.page-set {
  position: absolute;
  bottom: 0;
  width: 100%;
  color: var(--elTreeActiveColor);
  padding: 10px 0;
  text-align: center;
  display: block;
  border-top: 1px solid rgba(0, 0, 0, 0.07);
  font-size: 12px;
  line-height: 17px;
  box-sizing: border-box;
  i {
    display: inline-block;
    vertical-align: top;
    font-size: 14px;
    margin-right: 4px;
    &::before {
      color: var(--elTreeActiveColor);
    }
  }
}
.page-set:hover {
  color: var(--themeColorHover);
}
.page-list {
  width: 200px;
  padding-bottom: 42px;
  padding-top: 4px;
}
.page-list .dropdown-item-box {
  max-height: 400px;
  overflow-y: auto;
}
::v-deep .el-dropdown {
  color: var(--topOperationColor);
  font-size: 15px;
}
::v-deep .el-dropdown .el-icon-arrow-down {
  font-size: 12px;
}
.page-list ::v-deep .el-dropdown-menu__item {
  padding: 10px 12px;
  line-height: 20px;
  color: var(--textColor);
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background-color: #f0f2f7;
}
.page-list ::v-deep .el-dropdown-menu__item:not(.is-disabled):hover {
  color: var(--textColor);
  background-color: #f0f2f7;
}
.page-list ::v-deep .el-dropdown-menu__item.active {
  color: var(--elTreeActiveColor);
  font-weight: 500;
}
.page-list ::v-deep .el-dropdown-menu__item.active:hover {
  color: var(--elTreeActiveColor);
}
.page-list ::v-deep .el-dropdown-menu__item .icon-portal-icon {
  font-size: 16px;
  margin-right: 8px;
  display: inline-block;
  vertical-align: top;
  margin-top: 2px;
}
.page-list .icon-portal-icon::before {
  color: unset;
}
.previewSave {
  margin-left: 20px;
  .control-button {
    padding: 0;
    margin-left: 12px;
  }
}
.control-button .content-fit {
  width: auto;
  padding: 0 8px;
}
::v-deep .setDialog {
  width: 840px;
  height: 600px;
  border-radius: 8px;
  box-shadow: 0px 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 8px 20px rgba(0, 0, 0, 0.12);
  .el-dialog__header {
    padding: 15px 24px;
    .el-dialog__headerbtn {
      font-size: 20px;
      top: 14px;
      right: 14px;
    }
  }
  .el-dialog__title {
    font-weight: 600;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.8);
  }
  .el-dialog__body {
    height: calc(100% - 54px);
    padding: 0;
    .left-menu {
      width: 120px;
      height: 100%;
      float: left;
      border-right: 1px solid rgba(0, 0, 0, 0.07);
      padding: 16px;
      .menu-btn {
        display: block;
        width: 88px;
        padding: 10px 12px 10px 16px;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: rgba(0, 0, 0, 0.8);
        border-radius: 8px;
        margin-bottom: 4px;
        cursor: pointer;
        &.active {
          background: var(--themeColorSelectBg);
          font-weight: 600;
          color: var(--themeColor);
        }

        &:hover {
          background: #f0f2f7;
        }
      }
    }
    .right-content {
      width: calc(100% - 120px);
      height: 100%;
      float: left;
      overflow-y: auto;
      padding: 20px;
      color: rgba(0, 0, 0, 0.8);
      .el-checkbox {
        color: rgba(0, 0, 0, 0.8);
      }
      .basic-set {
        .backstage {
          width: 88px;
          height: 32px;
          padding: 0;
          background: transparent;
          color: var(--themeColor);
          border: 1px solid var(--themeColor);
          &:hover {
            border: 1px solid var(--themeColor);
            color: var(--themeColor);
            background-color: var(--defaultButtonHover);
          }
        }
        .locking {
          margin-top: 16px;
        }
        .tips {
          margin-top: 4px;
          margin-left: 24px;
          color: rgba(0, 0, 0, 0.4);
          font-size: 12px;
        }
      }

      .advanced-set {
        .form-item {
          margin-top: 18px;
        }
        .clear-tip {
          font-size: 13px;
          color: rgba(0, 0, 0, 0.4);
          margin-left: 12px;
        }
      }

      .form-item {
        margin-top: 30px;
        .label {
          font-weight: 500;
          font-size: 16px;
          line-height: 22px;
        }
        .el-checkbox-group {
          padding-top: 4px;
          .el-checkbox {
            display: block;
            margin-top: 10px;
          }
        }
        .el-checkbox {
          display: block;
          margin-top: 10px;
        }
        .theme-box {
          .theme-item {
            border: 1px solid #e9e9e9;
            border-radius: 6px;
            width: 180px;
            height: 126px;
            display: inline-block;
            vertical-align: top;
            margin-right: 24px;
            margin-top: 20px;
            overflow: hidden;
            cursor: pointer;
            .img-box {
              height: 90px;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .radio-box {
              border-top: 1px solid rgba(0, 0, 0, 0.07);
              padding: 8px;
            }
          }
        }
      }
      .shortcut-list {
        margin-top: 20px;
        li {
          width: calc((100% - 60px) / 2);
          height: 36px;
          line-height: 36px;
          margin-right: 60px;
          display: inline-block;
          margin-bottom: 12px;
          &:nth-child(2n) {
            margin-right: 0;
          }
          .left {
            float: left;
          }
          .right-key {
            float: right;
            .key {
              display: inline-block;
              vertical-align: top;
              margin-left: 4px;
              min-width: 36px;
              height: 36px;
              line-height: 36px;
              background: #f3f3f3;
              border-radius: 4px;
              text-align: center;
              padding: 0 12px;
            }
          }
        }
      }
    }
  }
}
.width82 {
  width: 82px;
}
.top-name-box {
  display: flex;
  align-items: center;
  .icon-right {
    margin-right: 4px;
    font-size: 16px;
    color: #656665;
  }
  .name {
    display: flex;
    align-items: center;
    padding: 6px 8px;
    i {
      font-size: 16px;
      margin-right: 6px;
    }
  }
}
.col0004 {
  color: rgba(0, 0, 0, 0.4);
}
.borderT1 {
  border-top: 1px solid rgba(240, 240, 240, 1);
}
  .page-list-dropdown{
    padding: 0 8px;
    line-height: 34px;
    border-radius: 8px;
    &:hover{
      background-color: var(--topControlHoverBg);
      .el-dropdown-link i{
        margin-top: 4px;
      }
    }
    .menu-show{
      i{
        transform: rotate(180deg);
      }
    }
  }
</style>
<style lang="scss">
/* 放大缩放下拉框 */
.el-popover.zoom-box-pop {
  padding: 0;
  .el-input {
    margin: 8px 12px;
    width: calc(100% - 24px);
  }
  .zoom-lists {
    padding: 4px 0;
    li {
      overflow: hidden;
      padding: 10px 12px;
      cursor: pointer;
      &:hover{
        background-color: var(--topControlHoverBg);
      }
      .list-icon {
        width: 16px;
        height: 16px;
        margin-right: 8px;
        display: inline-block;
        color: var(--themeColorIcon);
      }
      .list-label {
        color: var(--textColor);
      }
      .right-key {
        color: var(--thirdTextColor);
      }
    }
    .zoom-lists-line{
      border: none;
      border-top: 1px solid rgb(240, 240, 240);
      margin: 4px 0;
    }
  }
}
</style>
<style>
.width250 {
  width: 250px;
}
.control-button-more1.el-popover{
  padding: 0;
  background-color: transparent;
  border: 0;
  box-shadow: none;
}
</style>
<script>
import {
  _throttle,
  _debounce,
  encryption,
  replaceUrlParam,
  encryptionWorker,
  findAllRects,
  isExist,
  getAttrById,
  findCurrentComponentPathInLayoutByRectId,
  getQueryParam, hasProperty
} from "../../utils/index"
import { GetRequest } from "../../utils/initUrlQueryData"
import { buildModel } from "utils/buildModel.js"
import { data_dictionary_map } from "../../../static/dataDictionary"
import { parseAST } from "../../utils/parseDomAst/index"
import addPageTemplateDialog from "../publicComponent/addPageTemplateDialog/index.vue"
import { getErrorMessage } from "utils/errorMessageMap.js"
import { jsonCompress } from "utils/jsonCompress"
import { loading } from "utils/loading.js"
import {
  updateSubPageMapping,
  generateSubPageIdHandle,
  generateSubPageHandle
} from "utils/updateData/publicDataUtils/subPageUpdateData.js"
import { initPcStageData, initAppStageData } from "utils/initUrlQueryData"
import { DEFAULT_PAGELIST_ID, DEFAULT_PAGEDETAIL_ID } from "consts"
import plugins from "../../pagePlugin/index"
import { CATEGORY_MODE } from "@/consts/index.js"
export default {
  name: "top-operation",
  components: {
    addPageTemplateDialog
  },
  props: {
    headerSource: { type: Array, default: [] }
  },
  mixins: [plugins],
  data() {
    return {
      this1: this,
      form: {
        name: ""
      },
      leftDataSource: this.headerSource[0],
      centerDataSource: this.headerSource[1],
      rightDataSource: this.headerSource[2],
      isHandleData: false,
      isLock: false,
      selectedLanguage: 0,
      selectedPageInedex: 0,
      showPagesList: false,
      showLanguageList: false,
      previewResolve: null,
      languageLists: [
        {
          icon: "icon-portal-chinese-one",
          name: "简体中文"
        },
        {
          icon: "icon-portal-english",
          name: "英语"
        },
        {
          icon: "icon-portal-french",
          name: "法语"
        }
      ],
      timer: null,
      totalTime: 0,
      steps: [],
      recoverStep: [],
      setTempLateDialog: false,
      pagelist: [],
      pageIndex: 0,
      urlP: undefined,
      urlW: undefined,
      hp: undefined,
      curPageName: "",
      mouseover: false,
      autoSaveTimer: null,
      delayTime: 1000,
      setDialogShow: false,
      pointIndex: 0,
      leftMenuList: [
        {
          id: "theme",
          name: "主题设置"
        },
        {
          id: "key",
          name: "快捷键"
        },
        {
          id: "advanced",
          name: "高级功能"
        }
      ],
      toolCheckList: [],
      lockingChecked: false,
      ctrlKey: "",
      shiftKey: "",
      themeList: [
        {
          src: require("../../assets/images/theme/theme1.png"),
          name: "简约白"
        },
        {
          src: require("../../assets/images/theme/theme2.png"),
          name: "优雅红"
        },
        {
          src: require("../../assets/images/theme/theme3.png"),
          name: "活力黄"
        },
        {
          src: require("../../assets/images/theme/theme4.png"),
          name: "清新绿"
        },
        {
          src: require("../../assets/images/theme/theme5.png"),
          name: "经典蓝"
        }
      ],
      selectZoomOptions: [
        {
          value: "bigger",
          label: "放大",
          key: "⌘ +"
        },
        {
          value: "smaller",
          label: "缩小",
          key: "⌘ -"
        },
        {
          value: "50",
          label: "缩放至50%"
        },
        {
          value: "100",
          label: "缩放至100%",
          key: "⇧ 0"
        },
        {
          value: "200",
          label: "缩放至200%"
        }
      ],
      minZoom: 0.25,
      maxZoom: 2,
      setTemplatePageDialog: false, // 设置模板页面弹窗
      isCurrentPage: true,
      dialogObject: null,
      allRects: [],
      allRectsLayoutId: [],
      rectOutOfWaterFall: [],
      isSaveStatus: false,
      isPreviewStatus: false,
      isEditStatus: false,
      currentState: {},
      isAdmin: false,
      isSaving: false,
      isCollect: false,
      showRuler: false,
      showComponentName: false,
      // showAllComponent: false,
      managerType: 0,
      H5TemplateSaving: false,
      showPhoneLayer: false,
      zoomPopShow: false,
      setTempLateDialogAppendToBody: false,  //弹窗是否插入至 body 元素上
      menuShow: false,  //页面切换菜单展示
      repealStr: "撤销",
      recoverStr: "恢复",
    }
  },
  created() {
    this.getToolCheckList()
    setTimeout(() => {
      this.getPageList()
    }, 1000)
    this.urlW = this.GetRequest().w
    this.urlP = this.GetRequest().p
  },
  computed: {
    // managerType: {
    //   get() {
    //     return this.$store.state[this.request_prefix].page.managerType
    //   },
    //   set(val) {
    //     this.$changePageAttribute({ option_name: "managerType", option_val: val })
    //   }
    // },
    isSubHeadPage() {
      return this.$store.state[this.request_prefix].page.isSubHeadPage
    },
    historyList() {
      return this.$store.state.states.historyState
    },
    canGoBack() {
      return this.$store.state.states.historyIndex >= 0
    },
    canGoNext() {
      const { historyIndex, historyState } = this.$store.state.states
      return historyIndex < historyState.length - 1
    },
    isLoginPage: {
      get() {
        return this.$store.state[this.request_prefix].page.isLoginPage
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "isLoginPage", option_val: newVal })
        this.save("", this.request_prefix)
      }
    },
    pcWidth() {
      return Number(this.$store.state[this.request_prefix].page.referenceFontSize || 192)
    },
    appWidth() {
      return Number(this.$store.state[this.request_prefix].page.referenceFontSize || 41.4)
    },
    isPageScale: {
      get() {
        const page = this.$store.state[this.request_prefix].page
        return page.hasOwnProperty("isPageScale") ? page.isPageScale : true
        // return this.$store.state[this.request_prefix].page.isPageScale
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "isPageScale", option_val: newVal })
      }
    },
    isPhoneFullScreen() {
      return this.$store.state[this.request_prefix].page.isPhoneFullScreen
    },
    isLayout() {
      if (this.$store.state[this.request_prefix].page.isPhoneFullScreen) {
        // 翻页模版不能设置为布局模式
        return false
      }
      return this.$store.state[this.request_prefix].page.pageLayoutType
    },
    dataSource() {
      return this.$store.state[this.request_prefix]
    },
    activeId() {
      return this.$store.state.states.activeID
    },
    urlParams() {
      return this.$store.state.states.getDataPageIds
    },
    pageId() {
      return this.$store.state.states.getDataPageIds.pageId
    },
    pageListLength() {
      return this.$store.state.states.pageList.length
    },
    websiteId() {
      return this.$store.state.states.getDataPageIds.websiteId
    },
    homePageId() {
      return this.$store.state.states.getDataPageIds.homePageId
    },
    subPagePreview() {
      return !!this.$store.state.states.getDataPageIds.pv
    },
    subPageName() {
      return this.$store.state.states.getDataPageIds.name || ""
    },
    showLeftMenus: {
      get() {
        return this.$store.state.states.showLeftMenus
      },
      set(newVal) {
        this.$store.commit("states/changeShowLeftMenusStatus", newVal)
      }
    },
    showRightToolbar: {
      get() {
        return this.$store.state.states.showRightToolbar
      },
      set(newVal) {
        this.$store.commit("states/changeShowRightToolbarStatus", newVal)
      }
    },
    // 是否显示缩放按钮（false: 适应屏幕宽度）
    showAllScreen: {
      get() {
        return this.$store.state.states.showAllScreen
      },
      set(val) {
        this.$store.commit("states/changeShowAllScreenStatus", val)
      }
    },
    editPageThemeColor: {
      get() {
        let flag = this.$store.state[this.request_prefix].page.editPageThemeColor
        if (typeof flag === "undefined") {
          flag = 0
          this.$changePageAttribute({ option_name: "editPageThemeColor", option_val: flag }, true)
        }
        return Number(flag)
      },
      set(val) {
        this.$changePageAttribute({ option_name: "editPageThemeColor", option_val: val })
      }
    },
    zoomVal: {
      get() {
        return parseInt((this.zoom || 1) * 100)
      },
      set(val) {
        if (!this.showAllScreen) {
          this.topOperationSetting1(4)
        }
        let zoom = (val / 100).toFixed(2)
        if (zoom != this.zoom) {
          this.zoom = parseFloat(zoom)
        }
      }
    },
    selectZoomVal: {
      get() {
        return this.zoomVal + "%"
      },
      set(val) {
        if (val === "bigger") {
          this.zoomEditPage("zoomIn")
        } else if (val === "smaller") {
          this.zoomEditPage("zoomOut")
        } else {
          let zoom = (val / 100).toFixed(2)
          if (zoom != this.zoom) {
            this.zoom = parseFloat(zoom)
          }
        }
      }
    },
    zoom: {
      get() {
        let zoom = this.$store.state.states.zoom
        return zoom
      },
      set(val) {
        this.$store.commit("states/changePageZoom", val)
      }
    },
    // 判断当前网站是否只有移动端
    isOnlyPhonePageFlag() {
      let page = this.$store.state[this.request_prefix].page
      if (page.isPhoneFullScreen || page.isOnlyH5Template) {
        return true
      }
      return false
    },
    pageType() {
      return this.$store.state[this.request_prefix].type
    },
    isSubPage() {
      return this.pageType === "detailPage" || this.pageType === "listPage"
    },
    canUploadStyleToSystem() {
      let userPermissionCode = this.$store.state.states.userPermission
      return Array.isArray(userPermissionCode) && userPermissionCode?.indexOf(11) > -1 ? true : false
    },
    // 是否显示组件名称，默认不显示
    // showComponentName: {
    //   get() {
    //     return this.$store.state.states.showComponentName
    //   },
    //   set(newVal) {
    //     this.$store.commit("states/changeShowComponentName", newVal)
    //   }
    // },
    subPageEditInfo() {
      return this.$store.state.states.subPageEditInfo
    },
    showEditShape() {
      return this.$store.state.states.showEditShape || false
    },
    getOptions() {
      if (!isExist(this.activeId.rect_id)) return {}
      if (this.activeId.elementInAutoLayoutId !== undefined) {
        return this.getAttrById(this.$store.state[this.request_prefix], this.activeId, "elementInAutoLayout")
      }
      return this.getRectAttribute.call(this, this.activeId).options
    },
    deviceType() {
      if (this.pageType === "listPage" || this.pageType === "detailPage") {
        const pageId = this.$store.state.states.getDataPageIds.pageId
        let pcSubPage = localStorage.getItem("subPageSetting-" + this.urlParams.appId + "-stage")
        let appSubPage = localStorage.getItem("subPageSetting-" + this.urlParams.appId + "-appStage")
        if (pcSubPage && !appSubPage) {
          return 1
        }
        if (!pcSubPage && appSubPage) {
          return 2
        }
        if (pcSubPage && appSubPage) {
          pcSubPage = JSON.parse(pcSubPage)
          appSubPage = JSON.parse(appSubPage)
          const pcSubId = this.pageType === "listPage" ? pcSubPage.listPageId : pcSubPage.detailPageId
          const appSubId = this.pageType === "listPage" ? appSubPage.listPageId : appSubPage.detailPageId
          if (pcSubId === pageId && appSubId !== pageId) {
            return 1
          }
          if (pcSubId !== pageId && appSubId === pageId) {
            return 2
          }
        }
      }
      return 3
    },
    activeGridId: {
      get() {
        const activeGridId = this.$store.state.states.activeGridId
        return activeGridId
      },
      set(newVal) {
        this.$store.commit("states/changeActiveGridIdStatus", newVal)
      }
    },
  },
  watch: {
    pageId(n, o) {
      console.log("pageId", n)
    },
    pageListLength(n, o) {
      console.log("pageListLength", n)
    },
    subPageEditInfo: {
      deep: true,
      handler(n, o) {
        if (n.edit && n.type === "template") {
          this.changeSubPageTemplate()
          this.$store.state.states.subPageEditInfo.edit = false
        }
      }
    }
  },
  mounted() {
    document.title = getQueryParam("isSubHeadPage") ? "二级头页面" : this.leftDataSource.children[0].title
    this.$nextTick(() => {
      this.autoSave()
    })
    let isMac = /macintosh|mac os x/i.test(navigator.userAgent)
    if (isMac) {
      this.ctrlKey = "⌘"
      this.shiftKey = "⇧"
    } else {
      this.ctrlKey = "Ctrl"
      this.shiftKey = "Shift"
    }
    this.pageTabChange()
    /*临时操作*/
    console.log("admin", this.GetRequest().isLogin)
    this.isAdmin = this.GetRequest().isLogin ? true : false
    // 进入子页面时保持首页的管理员状态
    if (this.GetRequest().managerType == 1 && this.managerType != 1) {
      this.changeMangerType()
    }
    window.addEventListener("message", this.updateSubPageSettingMapping)
    // 取消模式区分，全部设置为专业模式，managerType: 1:管理员模式，2:普通模式
    this.$store.state.states.managerType = 1
  },
  methods: {
    setToolCheckList(type) {
      let param = {}
      let value = ""
      if (type === "ruler") {
        value = this.showRuler
        this.$store.commit("states/changeShowRulerStatus", !value)
      } else if (type === "comptName") {
        value = this.showComponentName
        this.$store.commit("states/changeShowComponentName", value)
      } else if (type === "width") {
        value = this.showAllScreen
        // this.$changePageAttribute({ option_name: "showAllScreen", option_val: value }, true)
        this.$store.commit("states/changeShowAllScreenStatus", value)
      } else if (type === "professional") {
        // value = this.showAllComponent
        // this.$changePageAttribute({ option_name: "managerType", option_val: Number(value) }, true)
        // this.$store.commit("states/changeManagerType", Number(value))
      } else if (type === "showPhoneLayer") {
        value = this.showPhoneLayer
        this.$store.commit("states/changeGeneralAttr", {
          valName: "showPhoneLayer",
          val: value
        })
      }
      param = {
        ruler: this.showRuler,
        comptName: this.showComponentName,
        width: this.showAllScreen,
        // professional: this.showAllComponent,
        showPhoneLayer: this.showPhoneLayer
      }
      this.$API.updatePreference(param).then(res => {})
    },
    getToolCheckList() {
      this.$API.getPreference().then(res => {
        console.log("res :>>", res)
        if (res.data.status === 200) {
          const data = res.data.data?.config
          if (!data || JSON.stringify(data) === "{}") return
          this.showRuler = data.ruler
          this.$store.commit("states/changeShowRulerStatus", !data.ruler)
          this.showComponentName = data.comptName
          this.$store.commit("states/changeShowComponentName", data.comptName)
          this.showAllScreen = data.width
          this.$store.commit("states/changeShowAllScreenStatus", data.width)
          // this.$changePageAttribute({ option_name: "showAllScreen", option_val: data.width }, true)
          // this.showAllComponent = data.professional
          // this.managerType = Number(data.professional)
          // this.$changePageAttribute({ option_name: "managerType", option_val: this.managerType }, true)
          // this.$store.commit("states/changeManagerType", this.managerType)
          this.showPhoneLayer = data.showPhoneLayer
          this.$store.commit("states/changeGeneralAttr", {
            valName: "showPhoneLayer",
            val: this.showPhoneLayer
          })
        }
      })
    },
    setTemplatePage(flag) {
      this.setTemplatePageDialog = true
      this.isCollect = flag
    },
    // 移动端同步pc端的数据
    syncBtnData() {
      if (this.isOnlyPhonePageFlag) {
        return
      }
      this.$confirm("同步数据后，会初始化并重置移动端的数据和样式，可能会导致数据丢失。确定同步吗？", "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        showClose: false,
        dangerouslyUseHTMLString: "",
        iconClass: "bigScreen_confirm_icon el-icon-warning",
        cancelButtonClass: "bigScreen_confirm_cancel_button",
        confirmButtonClass: "bigScreen_confirm_button",
        customClass: "bigScreen_confirm custom_warning_dialog"
      })
        .then(() => {
          //执行同步操作
          this.$emit("syncData")
        })
        .catch(err => {})
    },
    // 页面离开的时候不调用自动保存
    pageTabChange() {
      document.addEventListener("visibilitychange", this.visibilityStateChange)
    },
    visibilityStateChange() {
      if (document.visibilityState == "visible") {
        this.isCurrentPage = true
        this.autoSave()
      } else if (document.visibilityState == "hidden") {
        this.isCurrentPage = false
        clearTimeout(this.autoSaveTimer)
      }
    },
    changeDialog() {
      this.setDialogShow = true
    },
    getData() {
      console.log(this.$store.state[this.request_prefix])
    },
    toAdmin() {
      // copy于1.0
      window.open(this.getContextPath() + "/admin")
    },
    toLoginTemplate() {
      // 添加页面高度为100%的限制
      this.isLoginPage = !this.isLoginPage
    },
    toH5Template() {
      // 给独立的移动端模版添加标识
      // this.$changePageAttribute({ option_name: "isOnlyH5Template", option_val: true }, true)
      // this.save()
      this.H5TemplateSaving = true
      const drawer = $(".cutome-drawer-modal")
      const popover = $(".el-popover__open")
      if ((drawer && drawer.length > 0) || popover && popover.length > 0) {
        // 为了解决：抽屉弹窗开启中会挡住setTempLateDialog弹窗
        this.setTempLateDialogAppendToBody = true
      }else{
        this.setTempLateDialogAppendToBody = false
      }
      this.setTempLateDialog = true
    },
    // 对于文本
    editorTextHandle() {
      sessionStorage.setItem("editorTextHandle", true)
    },
    /* 获取父页面的公共路径p_contextpath */
    getContextPath() {
      // 通用版本此处不做处理。 带二级上下文的时候，此处进行修改
      var contextPath = ""
      if (window.hasOwnProperty("p_contextpath")) {
        contextPath = window["p_contextpath"]
      }
      return contextPath
    },
    GetRequest() {
      var url = location.href //获取url中"?"符后的字串
      var theRequest = new Object()
      if (url.indexOf("?") != -1) {
        var str = url.split("?")[1]
        var strs = str.split("&")
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1])
        }
      }
      return theRequest
    },
    getListOrder(contextPath, websiteId) {
      return this.$API.queryPageAttr({ websiteId: websiteId })
    },
    async getPageList() {
      let contextPath = window.hasOwnProperty("p_contextpath") ? window["p_contextpath"] : ""
      const { websiteId, pageId, sign, wfwfid } = this.$store.state.states.getDataPageIds
      const pageOrderData = await this.getListOrder(contextPath, websiteId)
      let pageOrder = pageOrderData?.data?.pageListJson
      pageOrder = pageOrder ? JSON.parse(pageOrder)?.pages : []
      this.$API
        .queryEditPageList({
          websiteId: websiteId,
          pageId: pageId
        })
        .then(res => {
          if (res.data.code === 1) {
            let pageList = res.data.data.pageList.sort((pageA, pageB) => {
              return pageOrder.length
                ? pageOrder.findIndex(i => i.pageId === pageA.publicId) -
                    pageOrder.findIndex(i => i.pageId === pageB.publicId)
                : 1
            })
            this.pagelist = pageList
            this.setPageType(pageList)
            if (pageList && pageList.length > 0 && this.pageType !== "listPage" && this.pageType !== "detailPage") {
              this.pagelist = pageList.filter(item => !item.template.includes("_sub") && !item.template.includes("_header"))
            }
            let homePageId = this.pagelist.find(item => item.isHomePage === 1)?.publicId
            window.sessionStorage.setItem("homePageId", homePageId)
            this.hp = res.data.data.homePage.publicId
            this.$store.commit("states/changePageList", this.pagelist)
            for (let i = 0; i < this.pagelist.length; i++) {
              if (this.pagelist[i].publicId == this.pageId) {
                this.curPageName = this.pagelist[i].name
                sessionStorage.setItem("createTime", this.pagelist[i].createTime)
                if (this.$store.state.states.subPageName && this.pageType === "listPage") {
                  this.curPageName = this.$store.state.states.subPageName
                } else {
                  this.curPageName = this.pagelist[i].name
                }
                document.title = this.isSubHeadPage ? "二级头页面" : this.curPageName
                console.log("this.curPageName", this.curPageName)
                break
              }
            }
          }
        })
    },
    setPageType(pageList) {
      let type = this.$store.state[this.request_prefix].type
      if (type === "listPage" || type === "detailPage") {
        return
      }
      let { pageId } = this.$store.state.states.getDataPageIds
      let curPageObj = pageList.find(item => item.publicId === pageId)
      const isSubHeadPage = this.$store.state[this.request_prefix].page.isSubHeadPage
      // 登录页面的时候pageList 为空，此时不能设置为平级页面
      if (curPageObj && curPageObj.isHomePage !== 1 && type !== "equalPage" && !isSubHeadPage) {
        // 将平级页面的类型修改为 equalPage，以便平级页面引用首页头底
        this.$store.dispatch(this.request_prefix + "/changePageType", "equalPage")
      }
    },
    handleClaerActive: _throttle(function () {
      this.$store.commit("states/changeElementType", null)
      this.$store.commit("states/changeToolBarStatus", false)
      this.$store.commit("states/changeAlignHelperStatus", false)
      if (this.activeGridId) {
        this.activeGridId = null
      }
    }, 500),
    pageSetClick() {
      let ids = this.$store.state.states.activeID
      this.$store.dispatch(this.request_prefix + "/unsetActive", {
        container_id: ids.container_id,
        rect_id: ids.rect_id
      })
      this.$store.commit("states/changeElementType", null)
      this.showRightToolbar = true
      if (this.activeGridId) {
        this.activeGridId = null
      }
    },
    async switchDevice(item, index) {
      if (this.request_prefix === "stage" && index === 0) {
        return
      }
      if (this.request_prefix === "appStage" && index === 1) {
        return
      }
      // this.handleClaerActive()
      this.$store.dispatch("operation/setActive", { id: index })
      const loadingStopCb = await loading()
      let ids = this.$store.state.states.activeID
      this.$store.dispatch(this.request_prefix + "/unsetActive", {
        container_id: ids.container_id,
        rect_id: ids.rect_id
      })
      this.$store.commit("states/changeElementType", null)
      // 切换设备的时候必须要传当前环境，
      // save 是一个异步操作，当接口返回来的时候全局的this.request_prefix已经发生了改变
      // this.save(undefined, this.request_prefix)
      this.$store.commit("states/clearHistoryState")
      this.$store.commit("states/clearPageZoom")
      const urlQuery = GetRequest()
      // loadingStopCb && loadingStopCb()
      // this.$store.commit("states/changeActiveID", null)
      if (index === 1 && this.$route.path !== "/appHome") {
        if (this.isSaving) {
          return
        }
        this.isSaving = true
        this.$store.commit("states/changeGeneralAttr", {
          valName: "zoom",
          val: 1
        })
        this.$set(this.$store.state.states.activeID, "activeID", {
          container_id: 0
        })
        this.$router.push({
          path: "/appHome",
          query: {
            ...urlQuery
          }
        })
        await this.getWebJsonData("stage")
      } else if (this.$route.path !== "/home" && index !== 1) {
        if (this.isSaving) {
          return
        }
        this.isSaving = true
        this.$set(this.$store.state.states, "activeID", {
          container_id: 0
        })
        this.$set(this.$store.state.states, "elementType", "page")
        this.$router.push({
          path: "/home",
          query: {
            ...urlQuery
          }
        })
        await this.getWebJsonData("appStage")
      }
      this.initPlugins()
    },
    async getWebJsonData(request_prefix) {
      // switchDevice 切换双端时不调用自动保存 mounted里调了 会导致定时器累加
      this.save(undefined, '', request_prefix, "switchDevice")
    },
    handle1stLevelAlign() {
      console.log("choose 1st level component")
    },
    handleElementInLayoutAlign() {
      console.log("choose elementInLayout component")
    },
    // 撤销
    goBackHandel() {
      if (this.canGoBack) {
        this.$undo()
      }
    },
    // 重做
    goNextHandel() {
      if (this.canGoNext) {
        this.$redo()
      }
    },
    // 根据url的键名获取值
    getUrlParam(name) {
      var reg = new RegExp("[?&]" + name + "=([^&#]+)")
      var query = window.location.href.match(reg)
      return query ? query[1] : null
    },
    // 自动保存
    autoSave() {
      // 开发环境不进行自动保存
      if (process.env.NODE_ENV === "development" || !this.isCurrentPage) {
        return
      }
      this.autoSaveTimer = setTimeout(() => {
        this.save(undefined, "自动保存成功")
      }, 180000)
      // 三分钟进行保存一次
    },
    // 保存
    judgeSaveHandle(){
      if(this.isSaveStatus || this.isPreviewStatus){
        return
      }
      this.save()
    },
    save: _throttle(function (statu, tipMessage, request_prefix, type) {
      this.saveHandler(tipMessage, request_prefix, type)
    }, 3000),
    saveHandler(tipMessage, request_prefix, type) {
      const isSubComponentDeleting = sessionStorage.getItem("isSubComponentDeleting")
      sessionStorage.removeItem("isSubComponentDeleting")
      if (this.subPagePreview) {
        return
      }
      if ((this.subPageEditInfo.edit && this.subPageEditInfo.type === "crumbs") || isSubComponentDeleting) {
        // 列表页修改面包屑设置项
        // 通知父页面保存
        window.opener.postMessage({
          type: "updateSubPageSettingMapping",
          data: { appId: this.urlParams.appId, prefix: this.request_prefix }
        })
        this.$store.state.states.subPageEditInfo.edit = false
      }
      this.isSaveStatus = !this.isSaveStatus
      const _self = this
      requestIdleCallback(
        async () => {
          // 清除逻辑文本的操作状态
          const logicTextDynamicId = this.$store.state.states.logicTextDynamicId
          if (document.getElementById(logicTextDynamicId + "")) {
            document.getElementById(logicTextDynamicId + "").style.background = ""
          }
          request_prefix = request_prefix || this.request_prefix
          if (this.pageType === "listPage") {
            this.$eventBus.$emit("updateSubPageStyle")
          }
          const param = _self.webjsonHandle(request_prefix)
          // 如果判断当前store数据不是来源于接口，禁止保存
          if (!param.isInitedFromInterface) {
            this.$message.error("检测到本地数据异常，禁止进行保存")
            _self.isSaveStatus = false
            return
          }
          // 开启新的布局模式
          if (this.getUrlParam("isWaterFall") === "true") {
            param.page.isWaterFall = "waterFall"
          }
          // 开启新的布局模式
          if (this.getUrlParam("isPageLayout") === "true") {
            param.page.pageLayoutType = "layOut"
          }
          if (request_prefix === "appStage") {
            /*... 将页面存为翻页模式*/
            let thisUrl = window.location.href
            if (this.getUrlParam("isPhoneFullScreen") === "true") {
              param.page.children.forEach(stage => {
                if (!stage.options) {
                  stage.options = {}
                }
                if (!stage.options.containerAnimateSet) {
                  stage.options.containerAnimateSet = {
                    direction: "upDown",
                    animateType: "regular",
                    animateClass__pageUp: "up",
                    animateClass__pageDown: "down",
                    nextAnimateClass: "",
                    prevAnimateClass: "",
                    isAutoPlay: false,
                    autoPlayDelay: 3
                  }
                }
              })
              this.$set(param.page, "isPhoneFullScreen", true)
              /*... 将旧的模版，转换只有移动端模式*/
              this.$set(param.page, "isOnlyH5Template", true)
            } else if (this.getUrlParam("isPhoneFullScreen") === "false") {
              /*... 将页面从翻页模式改回普通模式*/
              this.$set(param.page, "isPhoneFullScreen", false)
              /*... 将页面从旧的长页模版，转换成布局模式*/
              // this.$set(param.page, "pageLayoutType", "layOut")
              /*... 将旧的模版，转换只有移动端模式*/
              this.$set(param.page, "isOnlyH5Template", true)
            }
          }
          let paramApp
          const portalData = {
            encPageId: _self.$store.state.states.getDataPageIds.pageId,
            list: 1,
            domain: "138498cvm",
            version: param.version,
            w: this.$store.state.states.getDataPageIds.websiteId
          }
          if (request_prefix === "stage") {
            portalData.app = 0
            buildModel(param, _self.pcWidth)
            // 清除脏数据
            paramApp = _self.webjsonHandle("appStage")
            if (!paramApp.isInitedFromInterface) {
              this.$message.error("检测到本地数据异常，禁止进行保存")
              _self.isSaveStatus = false
              return
            }
            this.delUselessRect(paramApp)
            this.clearStoreOptionsAppId(paramApp)
            this.clearListPageClassifyComponent(paramApp)
          } else {
            portalData.app = 1
            buildModel(param, _self.appWidth)
          }
          console.log("param11", param)
          // 清除脏数据  暂时屏蔽处理项目问题，待优化后开启
          this.delUselessRect(param)
          this.clearStoreOptionsAppId(param)
          this.clearListPageClassifyComponent(param)
          let subPages = [],
            appSubPages = []
          if (!!paramApp) {
            const pcDatas = await encryptionWorker(param)
            const temp = JSON.parse(pcDatas)
            const paramAppIds = this.handleRefAppId(param, temp.page.appIdList)
            temp.page.appIdList = paramAppIds
            // 修改应用分页数量
            this.updatePageSize(paramAppIds)
            buildModel(paramApp, _self.appWidth)
            const appDatas = await encryptionWorker(paramApp)
            const tempApp = JSON.parse(appDatas)
            const appParamAppIds = this.handleRefAppId(paramApp, tempApp.page.appIdList)
            tempApp.page.appIdList = appParamAppIds
            if (temp.page.subPages) {
              subPages = temp.page.subPages
              delete temp.page.subPages
            }
            if (tempApp.page.subPages) {
              appSubPages = tempApp.page.subPages
              delete tempApp.page.subPages
            }
            // subPages里添加nav属性（true是导航，不是则无此属性）
            this.subPageNavHandle(subPages, appSubPages)
            subPages && (portalData.subPages = subPages)
            appSubPages && (portalData.appSubPages = appSubPages)
            portalData.content = temp
            portalData.appContent = tempApp
            // this.webjsonSplitHandle(portalData)
            // 双端webjson数据拆分
            portalData.content.page = JSON.parse(JSON.stringify(portalData.content.page).replace(/&quot;/g, "&qquot;"))
            portalData.appContent.page = JSON.parse(
              JSON.stringify(portalData.appContent.page).replace(/&quot;/g, "&qquot;")
            )
            // 压缩content、appContent
            portalData.content = jsonCompress(portalData.content)
            portalData.appContent = jsonCompress(portalData.appContent)
            this.$API
              .saveWebJsonPcApp({
                app: portalData.app,
                webJson: portalData
              })
              .then(res => {
                if (_self.isLatestVersion(res.data.message)) {
                  _self.$store.dispatch("stage/changeVersion")
                  _self.$store.dispatch("appStage/changeVersion")
                }
                _self.isSaveStatus = false
                _self.saveSuccessCb(res, tipMessage, type)
                _self.isSaving = false
              })
              .catch(err => {
                _self.isSaveStatus = false
                _self.$message({
                  customClass: "bigScreen_msg_backGroud",
                  duration: 3000,
                  message: err.message === "非法访问" ? "请登录后操作" : err.message || "保存失败",
                  type: "error"
                })
                _self.isSaving = false
              })
              .finally(() => {
                this.handleBeforePreview()
              })
          } else {
            const tempData = await encryptionWorker(param)
            const temp = JSON.parse(tempData)
            const paramAppIds = this.handleRefAppId(param, temp.page.appIdList)
            temp.page.appIdList = paramAppIds
            // 修改应用分页数量
            this.updatePageSize(paramAppIds)
            portalData.content = temp
            if (temp.page.subPages) {
              subPages = temp.page.subPages
              delete temp.page.subPages
            }
            portalData.content.page = JSON.parse(JSON.stringify(portalData.content.page).replace(/&quot;/g, "&qquot;"))
            // 独立移动端 清除pc端的数据
            if (
              _self.$store.state.appStage.page.isOnlyH5Template ||
              _self.$store.state.appStage.page.isPhoneFullScreen
            ) {
              portalData.content = ""
              portalData.appContent = temp
              this.subPageNavHandle(subPages, appSubPages)
              subPages && (portalData.appSubPages = subPages)
              // 压缩content、appContent
              portalData.appContent = jsonCompress(portalData.appContent)
              // 独立移动端仍然掉双端保存接口，pc端数据传空，以便后台统计应用
              this.$API
                .saveWebJsonPcApp({
                  app: portalData.app,
                  webJson: portalData,
                  at: 1
                })
                .then(res => {
                  if (_self.isLatestVersion(res.data.message)) {
                    _self.$store.dispatch("appStage/changeVersion")
                  }
                  _self.isSaveStatus = false
                  _self.saveSuccessCb(res, tipMessage, type)
                  _self.isSaving = false
                })
                .catch(err => {
                  _self.isSaveStatus = false
                  _self.$message({
                    customClass: "bigScreen_msg_backGroud",
                    duration: 3000,
                    message: err.message === "非法访问" ? "请登录后操作" : err.message || "保存失败",
                    type: "error"
                  })
                  _self.isSaving = false
                })
                .finally(() => {
                  this.handleBeforePreview()
                })
            } else {
              subPages && (portalData.appSubPages = subPages)
              portalData.content = temp
              // this.webjsonSplitHandle(portalData)
              portalData.content.page = JSON.parse(
                JSON.stringify(portalData.content.page).replace(/&quot;/g, "&qquot;")
              )
              // 压缩content、appContent
              portalData.content = jsonCompress(portalData.content)
              let at = 0
              if (
                _self.$store.state.appStage.page.isOnlyH5Template ||
                _self.$store.state.appStage.page.isPhoneFullScreen
              ) {
                // 供后端做预览使用（独立移动端预览，直接走带手机外壳的预览页面）
                // 0 是pc端   1是移动端
                at = 1
              }
              this.$API
                .saveWebJson({
                  app: portalData.app,
                  webJson: portalData,
                  at: at
                })
                .then(res => {
                  _self.isSaveStatus = false
                  _self.saveSuccessCb(res, tipMessage, type)
                  if (_self.isLatestVersion(res.data.message)) {
                    _self.$store.dispatch("appStage/changeVersion")
                  }
                  _self.isSaving = false
                })
                .catch(err => {
                  _self.isSaveStatus = false
                  _self.$message({
                    customClass: "bigScreen_msg_backGroud",
                    duration: 3000,
                    message: err.message === "非法访问" ? "请登录后操作" : err.message || "保存失败",
                    type: "error"
                  })
                  _self.isSaving = false
                })
                .finally(() => {
                  this.handleBeforePreview()
                })
            }
          }
        },
        {
          timeout: 500
        }
      )
    },
    handleBeforePreview() {
      this.previewResolve && this.previewResolve()
      this.previewResolve = null
    },
    judgeSaveSubPage(){
      if(this.isSaveStatus || this.isPreviewStatus){
        return
      }
      this.saveSubPage()
    },
    // 保存子页面
    async saveSubPage() {
      // 通知父页面保存
      window.opener.postMessage({
        type: "updateSubPageSettingMapping",
        data: { appId: this.urlParams.appId, prefix: this.request_prefix }
      })
      await this.getPreviewUrl()
      this.$message({
        customClass: "bigScreen_msg_backGroud",
        duration: 3000,
        type: "success",
        message: "保存成功"
      })
    },
    saveSubPageTemplate() {
      let newUrl = window.location.href
      newUrl += `&pv=${this.pageType === "listPage" ? 1 : 2}`
      window.location.href = newUrl
    },
    // subPages里添加nav属性（true是导航，不是则无此属性）
    subPageNavHandle(subPages, appSubPages) {
      if (subPages && subPages.length > 0) {
        // 找出所有的导航组件
        const navComponents = this.$store.state.stage.page.children[0].children.filter(
          item => item.shape === "cxNavMenu"
        )
        subPages.forEach(item => {
          // 根据appid找到导航组件
          navComponents.forEach(component => {
            if (component.options.appId === item.i0 || component.options.appId === item.appId) {
              item.nav = true
            }
          })
        })
      }
      if (appSubPages && appSubPages.length > 0) {
        // 找出所有的导航组件
        const navComponents = this.$store.state.appStage.page.children[0].children.filter(
          item => item.shape === "cxNavMenu"
        )
        appSubPages.forEach(item => {
          // 根据appid找到导航组件
          navComponents.forEach(component => {
            if (component.options.appId === item.i0 || component.options.appId === item.appId) {
              item.nav = true
            }
          })
        })
      }
    },
    // 双端拆分数据
    webjsonSplitHandle(param) {
      let pageData = JSON.parse(JSON.stringify(param))
      // 需要将当前webjson拆分成subPages、footer、header
      let data = {
        // 这些key不参与加密
        content_constant: {},
        header_constant: {},
        footer_constant: {},
        subPages_constant: []
      }
      let temp = this.webjsonHeadrFooterSplitHandle(pageData)
      if (temp) data = temp
      let subPages = []
      if (pageData.page.subPages) {
        subPages = JSON.parse(JSON.stringify(pageData.page.subPages))
        delete pageData.page.subPages
      }
      data.subPages_constant = subPages
      return JSON.parse(JSON.stringify(data))
    },
    // 拆分头底
    webjsonHeadrFooterSplitHandle(pageData) {
      if (!pageData.page.pageLayoutList) return {}
      let headerLayout = pageData.page.pageLayoutList.filter(item => item.options.inDocument === "header")[0]
      // 删除pageLayoutList中的header
      pageData.page.pageLayoutList = pageData.page.pageLayoutList.filter(item => item.options.inDocument !== "header")
      let headerComponentIds = findAllRects(headerLayout)
      let headerComponents = []
      // 根据rectId找到对应的组件，将其添加到当前页面
      headerComponentIds.forEach(rectId => {
        const component = this.getComponentByRectId(pageData.page, rectId)
        if (component) {
          headerComponents.push(component)
        }
        // 删除pageData.children[0].children中的组件
        pageData.page.children[0].children = pageData.page.children[0].children.filter(item => item.rect_id !== rectId)
      })
      let footerLayout = pageData.page.pageLayoutList.filter(item => item.options.inDocument === "footer")[0]
      // 删除pageLayoutList中的footer
      pageData.page.pageLayoutList = pageData.page.pageLayoutList.filter(item => item.options.inDocument !== "footer")
      let footerComponentIds = findAllRects(footerLayout)
      let footerComponents = []
      // 根据rectId找到对应的组件，将其添加到当前页面
      footerComponentIds.forEach(rectId => {
        const component = this.getComponentByRectId(pageData.page, rectId)
        if (component) {
          footerComponents.push(component)
        }
        // 删除pageData.children[0].children中的组件
        pageData.page.children[0].children = pageData.page.children[0].children.filter(item => item.rect_id !== rectId)
      })
      return {
        header_constant: {
          layout: headerLayout,
          components: headerComponents
        },
        footer_constant: {
          layout: footerLayout,
          components: footerComponents
        },
        content_constant: pageData
      }
    },
    // 处理平级页面、列表页、详情页，头底开启了同步首页头底的情况下，保存时剔除掉appIdList中的首页相关appId
    // 1. 面包屑id不需要
    // 2. appId可能会存在于跟options同级的appId, options.appId, options.myFecthParam.appId, 如果options.appId存在，则剔除同级appId, myFetchParam.appId
    handleRefAppId(param, originAppId) {
      let tempAppIdList = JSON.parse(JSON.stringify(originAppId || param?.page?.appIdList || []))
      if (!param.page.pageLayoutList) {
        return tempAppIdList
      }
      if (["detailPage", "listPage", "equalPage"].indexOf(param.type) > -1) {
        // 先获取头底通栏
        let headerLayout, footerLayout
        let rects = []
        param.page.pageLayoutList.forEach(layout => {
          if (layout.options.inDocument === "header" && layout.options.isRefHome === true) {
            headerLayout = layout
            rects = findAllRects(headerLayout)
          }
          if (layout.options.inDocument === "footer" && layout.options.isRefHome === true) {
            footerLayout = layout
            rects = rects.concat(findAllRects(footerLayout))
          }
        })
        // 遍历所有元素
        param.page.children[0].children.forEach(rect => {
          const _appId = rect?.appId
          const _fetchAppId = rect?.options?.myFetchParam?.appId
          const _optionsAppId = rect?.options?.appId
          const finalAppId = _optionsAppId || _appId || _fetchAppId
          const rect_id = rect.rect_id
          if (finalAppId) {
            // 如果是面包屑，剔除
            if (rect?.options?.innerElement === "cxBreadCrumbs") {
              const index = tempAppIdList.findIndex(i => i == finalAppId)
              index !== -1 && tempAppIdList.splice(index, 1)
            }
            if (rects.includes(rect_id)) {
              // 如果是头底的，剔除
              const rectIndex = rects.findIndex(i => i == rect_id)
              if (rectIndex !== -1) {
                const index = tempAppIdList.findIndex(i => i == finalAppId)
                index !== -1 && tempAppIdList.splice(index, 1)
              }
            }
            // 剔除fetch中的appId
            if (_fetchAppId && _fetchAppId !== finalAppId) {
              const index = tempAppIdList.findIndex(i => i == _fetchAppId)
              index !== -1 && tempAppIdList.splice(index, 1)
            }
            // 剔除跟options同级的appId
            if (_appId && _appId !== finalAppId) {
              const index = tempAppIdList.findIndex(i => i == _appId)
              index !== -1 && tempAppIdList.splice(index, 1)
            }
          }
        })
      }
      return tempAppIdList
    },
    // 双端数据处理函数
    webjsonHandle(request_prefix) {
      request_prefix = request_prefix || this.request_prefix
      const paramTemp = JSON.parse(JSON.stringify(this.$store.state[request_prefix]))
      console.log("paramTemp", paramTemp)
      // 逻辑文本需要将dom字符串转换成ast对象
      this.logicTextDomReseverAst(paramTemp)
      let param = JSON.parse(JSON.stringify(this.$store.state[request_prefix]))
      // 处理头部的显隐
      this.handleHeaderShow(param)
      delete param.page.cacheAppIds //删除无用数据结构
      delete param.page.nocacheAppIds //删除无用数据结构
      delete param.page.children[0].options.myFetchParam

      //  处理所有的自由布局，将tab的选中项全部改为第一个
      this.handleTabActive(param)
      this.clearEmptyLayoutComponent(param)
      this.clearDataForSource(param)
      // 处理头底同步首页头底的情况
      this.clearSubPageAppIds(param)
      // 清理抽屉脏数据
      this.clearDrawerData(param)
      param.version = param.version ? parseInt(param.version) + 1 : 1
      param.type = param.type ? param.type : "stage"
      param.event = this.$event.allEvents()
      console.log("param :>>", param)
      return param
    },
    // 开启变换肉步后，保存的时候将默认头部改为展示
    handleHeaderShow(webJson) {
      if (webJson.page.isShowHeader) {
        let header = webJson.page.pageLayoutList.find(item => item.options.inDocument === "header")
        let relativeHeader = webJson.page.pageLayoutList.find(item => item.options.inDocument === "relativeHeader")
        if (header) {
          header.options.isShow = true
        }
        if (relativeHeader) {
          relativeHeader.options.isShow = false
        }
      }
    },
    // 根据rectId找到对应的rect
    getComponentByRectId(stage, rectId) {
      for (let i in stage.children[0].children) {
        if (stage.children[0].children[i].rect_id === rectId) {
          return JSON.parse(JSON.stringify(stage.children[0].children[i]))
        }
      }
    },
    async saveSuccessCb(res, tipMessage, type) {
      // 页面初始进来自行保存不给用户提示语
      await this.getPreviewUrl()
      const saveNotNotice = sessionStorage.getItem("saveNotNotice")
      if (
        (tipMessage === null || typeof tipMessage === "undefined" || tipMessage.length > 0) &&
        saveNotNotice !== "true"
      ) {
        let message = res.data.code === 1 ? (tipMessage ? tipMessage : "保存成功") : getErrorMessage(res.data.message)
        if (res.data.code === 1) {
          // 自动保存成功  去掉toast
          if (message !== "自动保存成功" && type !== "switchDevice") {
            this.$message({
              customClass: "bigScreen_msg_backGroud",
              duration: 3000,
              message: message,
              type: "success"
            })
          }
        } else {
          if (message.indexOf("40003") > -1) {
            message = "登录状态异常，请检查"
          }
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            message: message,
            type: "warning"
          })
        }
      }
      if (type !== "switchDevice") {
        this.autoSave()
      }
    },
    // 组装预览地址
    async getPreviewUrl() {
      // 只有线上模式才需要提前构造iframe预览地址
      if (process.env.VUE_APP_MODE === "test" || process.env.NODE_ENV === "development") {
        return
      }
      let previewLink = ""
      if (this.pageType === "listPage" || this.pageType === "detailPage") {
        const { websiteId, wfwfid, appId, homePageId, engineInstanceId, hasEqualPage, equalHomePageId } = this.$store.state.states.getDataPageIds
        const { version } = this.$store.state[this.request_prefix]
        const subPage = JSON.parse(localStorage.getItem("subPageSetting-" + appId + "-" + this.request_prefix))
        const listPageId = subPage.listPageIsUseSystemTemplate ? DEFAULT_PAGELIST_ID : subPage.listPageId
        const detailPageId = subPage.detailPageIsUseSystemTemplate ? DEFAULT_PAGEDETAIL_ID : subPage.detailPageId
        const pageId = this.pageType === "listPage" ? listPageId : detailPageId
        const app = this.request_prefix === "appStage" ? "1" : "0"
        const urlQuery = GetRequest()
        const isNav = subPage?.nav
        const dataId = this.pageType === "detailPage" ? urlQuery.d : 0
        const typeId = (this.pageType === "detailPage" || isNav) && urlQuery.t ? urlQuery.t : 0
        let url = `/v2/sub/${pageId}/${engineInstanceId}/${typeId}/${dataId}/${homePageId}/${appId}/${websiteId}/${wfwfid}?app=${app}&version=${version}`
        if (hasEqualPage) {
          url += `&equalHomePageId=${equalHomePageId}&hasEqualPage=true`
        }
        if (process.env.VUE_APP_IS_MIRROR) {
          url = '/entry' + url
        }
        previewLink = await this.getPageUrl(url, homePageId)
      } else {
        // 首页
        const encPageId = this.$store.state.states.getDataPageIds.pageId
        previewLink = process.env.VUE_APP_IS_MIRROR ? `/entry/v2/p/${encPageId}` : `/v2/p/${encPageId}`
      }
      previewLink = window.location.origin + previewLink
      this.$emit("getPreviewUrl", previewLink)
    },
    clearEmptyLayoutComponent(param) {
      try {
        if (!param.page || Object.keys(param.page).length === 0) return
        param.page.children.forEach(container => {
          container.children.forEach(rect => {
            // 登录框组件 有需求需要记住选中的tab项
            if (
              rect.options.pluginName?.includes("loginEngineComponentPlugin") ||
              rect.options.pluginName?.includes("loginLayoutComponent")
            ) return
            if (rect.shape === "emptyLayoutComponent") {
              clearCol(rect?.options?.rows)
            }
          })
        })
        function clearCol(options) {
          let _rows = options
          if (_rows?.length) {
            for (let i = 0; i < _rows.length; i++) {
              if (_rows[i] && _rows[i].cols) {
                let itemCols = _rows[i].cols
                for (let k = 0; k < itemCols.length; k++) {
                  const elementOptions = itemCols[k]?.elementOptions
                  if (elementOptions?.length) {
                    itemCols[k].elementOptions = itemCols[k].elementOptions.filter(colEle => colEle?.options?.innerElement !== 'emptyLayoutComponent')
                  }
                  if (itemCols[k].rows && itemCols[k].rows.length) {
                    clearCol(itemCols[k].rows)
                  }
                }
              }
            }
          }
        }
      } catch (error){
        console.error(error)
      }
    },
    handleTabActive(param) {
      if (!param.page || Object.keys(param.page).length === 0) return
      param.page.children.forEach(container => {
        container.children.forEach(rect => {
          // 登录框组件 有需求需要记住选中的tab项
          if (
            rect.options.pluginName?.includes("loginEngineComponentPlugin") ||
            rect.options.pluginName?.includes("loginLayoutComponent")
          )
            return
          if (rect.shape === "cxTabs") {
            rect.options.activeIndex = 0
            return
          }
          if (rect.shape === "cxPageLayoutComponent") {
            let activeIndex = rect.options.layout?.options.activeIndex
            if (activeIndex !== null && typeof activeIndex !== "undefined") {
              rect.options.layout.options.activeIndex = 0
            }
            return
          }
          if (rect.shape !== "emptyLayoutComponent") {
            return
          }
          rect.options.activeIndex = 0
          if (rect.options.titleOptions?.length > 0) {
            rect.options.titleOptions.forEach(title => {
              title.elementOptions.forEach(element => {
                if (element.innerElement === "cxTabs") {
                  element.options.activeIndex = 0
                }
                if (element.innerElement === "cxTabs" && element.options.quoteTo === "cxTabs") {
                  // tab(使用下拉框样式的时候，预览页切换到第一个选项)
                  element.options.value = element.options.tabsList[0]?.name
                  return
                }
                if (element.innerElement === "cxPagination") {
                  element.options.value = 1
                }
              })
            })
          }
        })
      })
      // 通栏激活项修改
      param.page.pageLayoutList?.forEach(pageLayout => {
        if (pageLayout.options?.isShowTabs && pageLayout.options.hasOwnProperty("activeIndex")) {
          pageLayout.options.activeIndex = 0
        }
      })
    },
    // 清除连接数据源的组件内部数据，减少二次加载
    clearDataForSource(param) {
      if (!param.page || Object.keys(param.page).length === 0) return
      param.page.children.forEach(container => {
        container.children.forEach(rect => {
          if (rect.shape === "emptyLayoutComponent" && (rect.options.appId || rect.options.menuName === "登录组件")) {
            const useActiveIndex = rect.options.categoryMode === CATEGORY_MODE.SAME ? 0 : rect.options.activeIndex
            const topOptions = rect.options.rows[useActiveIndex]
            topOptions && travel(topOptions)
          }
        })
      })
      function travel(options) {
        if (options.cols) {
          options.cols.forEach(col => {
            travel(col)
          })
        } else if (options.rows) {
          options.rows.forEach(row => {
            travel(row)
          })
        } else {
          options.elementOptions.forEach(option => {
            if (
              option.innerElement === "imageComponent" &&
              (option.filedMapping?.value || option.loginType === "loginImage")
            ) {
              option.imgSrc = ""
            }
            if (option.innerElement === "cxVideo" && option.filedMapping?.flag) {
              option.videoUrl = ""
            }
            if (option.innerElement === "cxAudio" && option.filedMapping?.flag) {
              option.audioUrl = ""
            }
          })
        }
      }
    },
    // 清理子页面，头底如果是同步首页头底的情况下，保存时剔除掉appIdList中的首页相关appId，以及对应组件的appId字段
    // 平级页面先不清除 清除了子页面同步会有问题
    clearSubPageAppIds(param) {
      if (["detailPage", "listPage"].indexOf(param.type) > -1) {
        // 先获取头底通栏
        let headerLayout, footerLayout
        let rects = []
        param.page.pageLayoutList.forEach(layout => {
          if (layout.options.inDocument === "header" && layout.options.isRefHome === true) {
            headerLayout = layout
            rects = findAllRects(headerLayout)
          }
          if (layout.options.inDocument === "footer" && layout.options.isRefHome === true) {
            footerLayout = layout
            rects = rects.concat(findAllRects(footerLayout))
          }
        })
        // 遍历所有元素
        param.page.children[0].children.forEach(rect => {
          const _appId = rect?.appId
          const _fetchAppId = rect?.options?.myFetchParam?.appId
          const _optionsAppId = rect?.options?.appId
          const finalAppId = _optionsAppId || _appId || _fetchAppId
          const rect_id = rect.rect_id
          if (finalAppId) {
            // 如果是面包屑，剔除
            if (rect?.options?.innerElement === "cxBreadCrumbs") {
              const index = param.page.appIdList.findIndex(i => i == finalAppId)
              index !== -1 && param.page.appIdList.splice(index, 1)
            }
            // 如果是自由布局组件，删除options.myFetchParam.appId
            if (rect?.options?.innerElement === "emptyLayoutComponent" && rect.options.myFetchParam?.appId) {
              rect.options.myFetchParam.appId = ""
            }
            if (rects.includes(rect_id)) {
              // 如果是头底的，剔除
              const rectIndex = rects.findIndex(i => i == rect_id)
              if (rectIndex !== -1) {
                const index = param.page.appIdList.findIndex(i => i == finalAppId)
                index !== -1 && param.page.appIdList.splice(index, 1)
                // 删除appId
                if (_fetchAppId) {
                  rect.options.myFetchParam.appId = ""
                }
                if (_appId) {
                  rect.appId = ""
                }
                if (_optionsAppId) {
                  rect.options.appId = ""
                }
              }
            }
          }
        })
      }
    },
    // 清理抽屉按钮被删除，但是对应的抽屉组件，及其子组件未被删除的数据
    clearDrawerData(param) {
      // 判断是否有pageLayoutList
      if (!param.page?.pageLayoutList) return
      const pageLayoutList = JSON.parse(JSON.stringify(param.page.pageLayoutList))
      pageLayoutList.forEach(pageLayout => {
        if (pageLayout.options?.inDocument === "drawer") {
          // const hasDrawerBtn = param.page.children[0].children.findIndex(
          //   item => item.drawerPath === pageLayout.options.source_id
          // )
          const hasDrawerComponent = document.getElementsByClassName(pageLayout.options.source_id).length
          if (!hasDrawerComponent && pageLayout.options.source_id !== 'notice_drawer') {
            // 如果抽屉按钮被删除，但是抽屉组件未被删除，清空抽屉组件数据
            const rectIds = findAllRects(pageLayout)
            param.page.children[0].children = param.page.children[0].children.filter(
              item => !rectIds.includes(item.rect_id)
            )
            const pageLayoutIndex = param.page.pageLayoutList.findIndex(item => item.id === pageLayout.id)
            pageLayoutIndex !== -1 && param.page.pageLayoutList.splice(pageLayoutIndex, 1)
          }
        }
      })
    },
    getPageUrl(url, pageId) {
      // 校验url参数，校验规则，只校验？前面的部分，将null、undefined、空字符串的参数用0替换
      const urlArr = url.split("?")[0]
      // 将urlArr用/分割，然后将null、undefined、空字符串的参数用0替换
      const urlArrSplit = urlArr.split("/").slice(3)
      const urlArrSplitNew = urlArrSplit.map(item => {
        if (item === "" || item === "null" || item === "undefined") {
          return "0"
        }
        return item
      })
      const urlNew = urlArrSplitNew.join("/")
      // 将urlArrSplit拼接上?后面的参数
      url = "/v2/sub/" + urlNew + "?" + url.split("?")[1]
      let pageUrl = ""
      return this.$API.addSubPageLink({ u: url, p: pageId }).then(res => {
        const { code, data } = res.data
        if (code === 1) {
          if (process.env.NODE_ENV === "development") {
            if (this.request_prefix === "appStage") {
              pageUrl = `//mh.chaoxing.com/mhssr/?uuid=${data}&a=1`
            } else {
              pageUrl = `//mh.chaoxing.com/mhssr/?uuid=${data}`
            }
          } else {
            pageUrl = `/v2/sub/${data}`
          }
          return pageUrl
        }
      })
    },
    judgePreviewHandle(){
      if(this.isPreviewStatus || (this.isSaveStatus && !this.previewResolve)){
        return
      }
      this.preview()
    },
    preview: _throttle(function () {
      this.isPreviewStatus = true
      const _self = this
      if (this.pageType === "listPage" || this.pageType === "detailPage") {
        // 组装子页面地址
        new Promise(resolve => {
          this.previewResolve = resolve
          if(this.$store.state.states.generatingCopyLink) {
            this.previewResolve()
            this.previewResolve = null
          } else {
            this.saveHandler()
          }
        }).then(() => {
          const { websiteId, wfwfid, appId, homePageId, engineInstanceId, typeId, hasEqualPage, equalHomePageId } = this.$store.state.states.getDataPageIds
          const { version } = this.$store.state[this.request_prefix]
          const subPage = JSON.parse(localStorage.getItem("subPageSetting-" + appId + "-" + this.request_prefix))
          const listPageId = subPage.listPageIsUseSystemTemplate ? DEFAULT_PAGELIST_ID : subPage.listPageId
          const detailPageId = subPage.detailPageIsUseSystemTemplate ? DEFAULT_PAGEDETAIL_ID : subPage.detailPageId
          const pageId = this.pageType === "listPage" ? listPageId : detailPageId
          const app = this.request_prefix === "appStage" ? "1" : "0"
          const urlQuery = GetRequest()
          const isNav = subPage?.nav
          const dataId = this.pageType === "detailPage" ? urlQuery.d : 0
          // const typeId = (this.pageType === "detailPage" || isNav) && urlQuery.t ? urlQuery.t : 0
          // 为了保证uuid一致，version不更新，传入undefined
          let url = `/v2/sub/${pageId}/${engineInstanceId}/${typeId}/${dataId}/${homePageId}/${appId}/${websiteId}/${wfwfid}?app=${app}&version=${version}`
          if (hasEqualPage) {
            url += `&equalHomePageId=${equalHomePageId}&hasEqualPage=true`
          }
          this.getPageUrl(url, homePageId)
            .then(previewLink => {
              this.isPreviewStatus = false
              if(this.$store.state.states.generatingCopyLink) {
                this.$store.commit("states/changeCopyLinkStatus", false)
                this.$eventBus.$emit("after-copyLick-generate", previewLink)
                return
              }
              if (this.request_prefix === "stage") {
                window.open(previewLink, "_blank")
              } else {
                let routeLink = this.$router.resolve({
                  path: "/ssrPreview",
                  params: { link: previewLink }
                })
                localStorage.setItem(
                  "routerParams",
                  JSON.stringify({
                    link: previewLink?.includes("http") ? previewLink : previewLink?.startsWith("//") ? window.location.protocol + previewLink : window.location.origin + previewLink,
                    title: _self.curPageName,
                    isPhoneFullScreen: _self.$store.state[_self.request_prefix].page.isPhoneFullScreen,
                    isOnlyH5Template: _self.$store.state[_self.request_prefix].page.isOnlyH5Template,
                    pageType: _self.pageType,
                    appId: appId
                  })
                )
                window.open(routeLink.href, "_blank")
              }
            })
            .catch(e => {
              this.isPreviewStatus = false
            })
        })
        return
      }
      requestIdleCallback(
        async () => {
          const paramTemp = JSON.parse(JSON.stringify(this.$store.state[this.request_prefix]))
          this.logicTextDomReseverAst(paramTemp)
          let param = JSON.parse(JSON.stringify(this.$store.state[this.request_prefix]))
          this.handleHeaderShow(param)
          if (!param.isInitedFromInterface) {
            this.$message.error("检测到本地数据异常，禁止进行预览")
            _self.isPreviewStatus = true
            return
          }
          //  处理所有的自由布局，将tab的选中项全部改为第一个
          this.handleTabActive(param)
          // 清理脏数据
          this.delUselessRect(param)
          this.clearStoreOptionsAppId(param)
          this.clearListPageClassifyComponent(param)
          param.version = parseInt(param.version) + 1
          //将事件保存到webJson
          console.log("this.$event.allEvents() :>> ", this.$event.allEvents())
          param.event = this.$event.allEvents()
          const portalData = {
            encPageId: this.$store.state.states.getDataPageIds.pageId,
            list: 1,
            domain: "138498cvm",
            version: param.version,
            w: this.$store.state.states.getDataPageIds.websiteId
          }
          if (this.request_prefix === "stage") {
            portalData.app = 0
            buildModel(param, this.pcWidth)
          } else {
            portalData.app = 1
            buildModel(param, this.appWidth)
          }
          const temp = encryption(param, data_dictionary_map)
          let tempObj = JSON.parse(temp)
          const paramAppIds = this.handleRefAppId(param, tempObj.page.appIdList)
          tempObj.page.appIdList = paramAppIds
          // 修改应用分页数量
          this.updatePageSize(paramAppIds)
          if (tempObj?.page?.subPages) {
            const tempSubPages = tempObj?.page?.subPages || []
            delete tempObj.page.subPages
            portalData.app == 0 ? (portalData.subPages = tempSubPages) : (portalData.appSubPages = tempSubPages)
          }

          tempObj = jsonCompress(tempObj)
          portalData.content = JSON.stringify(tempObj)
          portalData.content = portalData.content.replace(/&quot;/g, "&qquot;")

          let at = 0
          if (
            portalData.app == 1 &&
            (_self.$store.state.appStage.page.isOnlyH5Template || _self.$store.state.appStage.page.isPhoneFullScreen)
          ) {
            // 供后端做预览使用（独立移动端预览，直接走带手机外壳的预览页面）
            // 0 是pc端   1是移动端
            at = 1
          }
          const _this = this
          _this.$API
            .previewPage({
              app: portalData.app,
              webJson: portalData,
              at: at
            })
            .then(res => {
              this.isPreviewStatus = false
              if (_self.isLatestVersion(res.data.data.message)) {
                _self.$store.dispatch(this.request_prefix + "/changeVersion")
              }
              let previewLink
              if (process.env.VUE_APP_MODE === "test" || process.env.NODE_ENV === "development") {
                const encWebSitedId = this.$store.state.states.getDataPageIds.websiteId
                const wfwfid = this.$store.state.states.getDataPageIds.wfwfid
                previewLink = `//mh.chaoxing.com/mhssr/?p=${portalData.encPageId}&w=${encWebSitedId}&wf=${wfwfid}&a=${portalData.app}&v=${portalData.version}`
              } else {
                previewLink = res.data.data.url + `/v2/p/${portalData.encPageId}`
                if (process.env.VUE_APP_IS_MIRROR) {
                  previewLink = res.data.data.url + `/entry/v2/p/${portalData.encPageId}`
                }
              }
              if(this.$store.state.states.generatingCopyLink) {
                this.$store.commit("states/changeCopyLinkStatus", false)
                this.$eventBus.$emit("after-copyLick-generate", previewLink)
                return
              }
              if (this.request_prefix === "stage") {
                window.open(previewLink, "_blank")
              } else {
                let routeLink = this.$router.resolve({
                  path: "/ssrPreview",
                  params: { link: previewLink }
                })
                localStorage.setItem(
                  "routerParams",
                  JSON.stringify({
                    link: previewLink,
                    title: _self.curPageName,
                    isPhoneFullScreen: _self.$store.state[_self.request_prefix].page.isPhoneFullScreen,
                    isOnlyH5Template: _self.$store.state[_self.request_prefix].page.isOnlyH5Template
                  })
                )
                window.open(routeLink.href, "_blank")
              }
            })
            .catch(err => {
              this.isPreviewStatus = false
              this.$message({
                customClass: "bigScreen_msg_backGroud",
                duration: 3000,
                message: err.message === "非法访问" ? "请登录后操作" : err.message || "预览失败",
                type: "error"
              })
              console.log(err)
            })
        },
        {
          timeout: 500
        }
      )
    }, 3000),
    // 保存前清理一遍脏数据
    getAllRects(layout) {
      if(!layout){
        return
      }
      let curLayout = layout
      if (layout.rectIds && layout.rectIds.length > 0) {
        this.allRects = this.allRects.concat(layout.rectIds)
        if (layout.options.waterFlow) {
          layout.options.gridLayout?.forEach(grid => {
            this.allRectsLayoutId.push(grid.i)
          })
        } else {
          this.rectOutOfWaterFall = this.rectOutOfWaterFall.concat(layout.rectIds)
        }
      }
      curLayout.layout.rows.forEach(item => {
        this.getAllRects(item)
      })
      curLayout.layout.cols?.forEach(item => {
        this.getAllRects(item)
      })
    },
    deleteLayoutId(layout, rectIds) {
      let curLayout = layout
      if (curLayout.rectIds && curLayout.rectIds.length > 0) {
        for (let i = 0; i < curLayout.rectIds.length; i++) {
          if (!rectIds.includes(curLayout.rectIds[i])) {
            curLayout.rectIds.splice(i, 1)
            i--
          }
        }
      }
      curLayout.layout.rows.forEach(item => {
        this.deleteLayoutId(item, rectIds)
      })
      curLayout.layout.cols?.forEach(item => {
        this.deleteLayoutId(item, rectIds)
      })
    },
    delUselessRect(param) {
      if ((param.page.pageLayoutType !== "layOut" && !param.page.isWaterFall) || !param.page.pageLayoutList) {
        return
      }
      // 目前只有布局模有这种情况
      this.allRects = []
      this.allRectsLayoutId = []
      this.rectOutOfWaterFall = []
      param.page.pageLayoutList.forEach(layout => {
        this.getAllRects(layout)
      })
      param.page.children[0].children.forEach(rect => {
        if (rect.shape === "cxPageLayoutComponent" && this.allRects.indexOf(rect.rect_id) > -1) {
          this.getAllRects(rect.options.layout)
        }
      })
      let children = param.page.children[0].children
      for (let i = 0; i < children.length; i++) {
        let _index = this.allRects.findIndex(rectId => rectId == children[i].rect_id)
        if (_index === -1) {
          children.splice(i, 1)
          i--
        } else if (children[i].i && this.allRectsLayoutId.indexOf(children[i].i) === -1) {
          children.splice(i, 1)
          i--
        } else if (
          param.page.isWaterFall &&
          !children[i].i &&
          this.rectOutOfWaterFall.indexOf(children[i].rect_id) === -1
        ) {
          // 组件不在栅格下
          children.splice(i, 1)
          i--
        }
      }
      const rectIds = children.map(child => child.rect_id)
      param.page.pageLayoutList.forEach(layout => {
        this.deleteLayoutId(layout, rectIds)
      })
      param.page.children[0].children.forEach(rect => {
        if (rect.shape === "cxPageLayoutComponent") {
          this.deleteLayoutId(rect.options.layout, rectIds)
        }
      })
    },
    // 清除列表页中列表组件中的storeOptions中的appId属性
    clearStoreOptionsAppId(param) {
      if (this.pageType === "listPage") {
        // 找到列表组件
        param.page.children[0].children.forEach(rect => {
          if (rect.shape === "emptyLayoutComponent" && rect.hasOwnProperty("storeOptions")) {
            Object.keys(rect.storeOptions).forEach(key => {
              delete rect.storeOptions[key].appId
              delete rect.storeOptions[key]?.myFetchParam?.appId
            })
          }
        })
      }
    },
    // 清除列表页中列表组件中的多余的cxNavMenuVertical、cxMultiFilter
    clearListPageClassifyComponent(param) {
      if (this.pageType === "listPage") {
        this.clearListPageClassifyComponentHandle(param, ["listPageNavMenuDrawerPlugin"], "cxNavMenuVertical")
        this.clearListPageClassifyComponentHandle(param, ["listPageMultiFilterDrawerPlugin","appMultiFilterDrawerPlugin"], "cxMultiFilter")
      }
    },
    clearListPageClassifyComponentHandle(param, plugin, shape) {
      const rectAttr = param.page.children[0].children.find(rect => rect.shape === shape)
      if (!rectAttr) return
      // 找到当前页面的导航菜单组件所在的通栏
      const layout = param.page.pageLayoutList
      const path = findCurrentComponentPathInLayoutByRectId(layout, rectAttr.rect_id).join("_")
      const options = getAttrById(
        param,
        {
          pageLayoutId: path
        },
        "pageLayoutId"
      )
      const rectIds = options.rectIds
      if (options?.options?.drawerParams?.isDrawerMode) {
        // 查看当前抽屉按钮是否被删除
        // 找到列表组件
        let isDirty = true
        param.page.children[0].children.forEach(rect => {
          const pluginIndex = plugin.findIndex(item=> rect.options.pluginName?.includes(item))
          // if (rect.shape === "cxButton" && rect.options.pluginName.includes(plugin)) {
          if (rect.shape === "cxButton" && pluginIndex > -1) {
            isDirty = false
          }
        })
        if (isDirty) {
          // 删除抽屉中的脏组件
          if (rectIds.length > 0) {
            param.page.children[0].children = param.page.children[0].children.filter(
              item => !rectIds.includes(item.rect_id)
            )
          }
        }
      }
    },
    requestLoop(url, portalData) {
      const _this = this
      _this.instance.get(`v2/webjson/${portalData.encPageId}/html-status?a=${portalData.app}`).then(res => {
        const timer2 = new Date().getTime()
        if (res.data.code == 1) {
          window.open(url)
        } else {
          if (_this.totalTime < 10000) {
            if (timer2 - _this.timer < 3000) {
              let newt = 3000 - (timer2 - _this.timer)
              _this.totalTime += newt
              setTimeout(function () {
                _this.timer = new Date().getTime()
                _this.requestLoop(url, portalData)
              }, newt)
            } else {
              _this.totalTime += timer2 - _this.timer
              _this.timer = new Date().getTime()
              _this.requestLoop(url, portalData)
            }
          } else {
            this.$message({
              customClass: "bigScreen_msg_backGroud",
              duration: 3000,
              message: "预览失败",
              type: "error"
            })
          }
        }
      })
    },
    // 在buildModel之前，判断当前rect类型，如果是逻辑文本组件，再调用将dom转ast函数并保存在vuex中
    logicTextDomReseverAst(param) {
      // param.page不为空对象
      if (!param.page || Object.keys(param.page).length === 0) return
      for (let i = 0; i < param.page.children.length; i++) {
        const container = param.page.children[i]
        for (let j = 0; j < container.children.length; j++) {
          const rect = container.children[j]
          if (rect.shape === "cxAutoLayout") {
            rect.elementOptions?.forEach(element => {
              if (element.innerElement === "cxLogicText") {
                const ast = parseAST(document.getElementById("logicTextContent-" + container.container_id + "-" + rect.rect_id)?.innerHTML)
                if (ast) {
                  this.$changeOptionsEV(ast, "ast", false, undefined, {
                    container_id: container.container_id,
                    rect_id: rect.rect_id,
                    elementInAutoLayoutId: element.elementInAutoLayoutId
                  })
                }
              }
            })
          }
          if (rect.shape === "cxLogicText") {
            const ast = parseAST(
              document.getElementById("logicTextContent-" + container.container_id + "-" + rect.rect_id)?.innerHTML
            )
            if (ast) {
              this.$changeOptionsEV(ast, "ast", false, undefined, {
                container_id: container.container_id,
                rect_id: rect.rect_id
              })
            }
          }
        }
      }
    },
    changeLockStatu() {
      this.isLock = !this.isLock
    },
    saveToTemplate() {
      const drawer = $(".cutome-drawer-modal")
      const popover = $(".el-popover__open")
      if ((drawer && drawer.length > 0) || popover && popover.length > 0) {
        // 为了解决：抽屉弹窗开启中会挡住setTempLateDialog弹窗
        this.setTempLateDialogAppendToBody = true
      }else{
        this.setTempLateDialogAppendToBody = false
      }
      this.setTempLateDialog = true
    },
    changeRulerStatu() {
      this.showRuler = !this.showRuler
    },
    postTemplateData() {
      this.setTempLateDialog = false
      if (!this.form.name.trim().length) {
        this.H5TemplateSaving = false
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          message: "模板名称不能为空！",
          type: "warning"
        })
        return
      }
      if (this.form.name.trim().length > 50) {
        this.H5TemplateSaving = false
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          message: "模板名称过长 请修改名称后重新保存",
          type: "warning"
        })
        return
      }
      let typeId = 202
      if (this.isOnlyPhonePageFlag || this.H5TemplateSaving) {
        typeId = 203
        this.H5TemplateSaving = false
      }
      this.$API
        .setMyTemplate({
          websiteId: this.$route.query.w,
          param: {
            name: this.form.name,
            typeId: typeId
          }
        })
        .then(res => {
          if (res.data.status !== 200 || res.data.code === 0) {
            return Promise.reject({ message: res?.data?.message })
          }
          this.form.name = ""
          this.$message({ customClass: "bigScreen_msg_backGroud", type: "success", message: "保存成功" })
        })
        .catch(err => {
          this.$message({
            type: "error",
            customClass: "bigScreen_msg_backGroud",
            message: getErrorMessage(err?.message, true) || "保存失败"
          })
        })
    },
    // 切换下拉选项
    changeSelectItem(key, title, index) {
      this[key] = index
      document.title = title
    },
    // 切换下拉选项
    handleCommand(index) {
      if (this.pageId === this.pagelist[index].publicId) {
        return
      }
      if(index !== 0){
      //  说明不是首页，是平级页面
        sessionStorage.setItem("isEqualPage", true) // 标记当前跳转的页面是平级页面
      }
      // 跳转到其他编辑页
      let nUrl = window.location.href.replace(/p=([^&]*)/gi, `p=${this.pagelist[index].publicId}`)
      if (nUrl.indexOf("&hp=") > -1) {
        nUrl = nUrl.replace(/hp=([^&]*)/gi, `hp=${this.hp}`)
      } else {
        nUrl = `${nUrl}&hp=${this.hp}`
      }
      window.location.href = nUrl
    },
    // 关闭下拉列表
    closeSelectList(showflag) {
      this[showflag] = false
    },
    openSelectList(showflag) {
      this[showflag] = true
    },
    clearAllRect() {
      this.$confirm("清空内容后页面内的所有组件将会消失, 是否继续?", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        showClose: false,
        iconClass: `${this.request_prefix}_confirm_icon el-icon-warning`,
        cancelButtonClass: `${this.request_prefix}_confirm_cancel_button`,
        confirmButtonClass: `${this.request_prefix}_confirm_button`,
        customClass: `${this.request_prefix}_confirm custom_warning_dialog`
      })
        .then(() => {
          if (this.isLayout) {
            this.$store.commit("states/changeElementType", null)
          } else {
            this.$store.commit("states/changeActiveID", { container_id: 0 })
            this.$store.commit("states/changeElementType", "container")
          }
          this.$store.dispatch(this.request_prefix + "/clearAllRect")
          this.$store.commit("states/clearHistoryState")
          this.$message({
            type: "success",
            duration: 2000,
            message: "清空成功!"
          })
        })
        .catch(action => {
          if (action === "cancel") return
          this.$message({
            type: "info",
            message: "清空失败"
          })
        })
    },
    pointClick(id, index) {
      document.getElementById(id).scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest"
      })
      this.pointIndex = index
    },
    changeStyleColor(id) {
      this.editPageThemeColor = id
    },
    zoomEditPage(val) {
      let STEP = 0.05
      if (val === "zoomIn") {
        this.zoom = this.zoom + STEP > this.maxZoom ? this.maxZoom : Number((this.zoom + STEP).toFixed(2))
      } else if (val === "zoomOut") {
        this.zoom = this.zoom - STEP < this.minZoom ? this.minZoom : Number((this.zoom - STEP).toFixed(2))
      }
    },
    // 放大缩放选择
    selectZoomFunc(item, index) {
      if (!this.showAllScreen) {
        this.topOperationSetting1(4)
      }
      if (item.value === "bigger") {
        this.zoomEditPage("zoomIn")
      } else if (item.value === "smaller") {
        this.zoomEditPage("zoomOut")
      } else {
        if (this.zoom * 100 === Number(item.value)) {
          this.zoomPopShow = false
          return
        }
        let zoom = (item.value / 100).toFixed(2)
        if (zoom != this.zoom) {
          this.zoom = parseFloat(zoom)
        }
        this.$message({
          type: "success",
          message: "缩放至" + item.value + "%"
        })
        this.zoomPopShow = false
      }
    },
    getFocus(event) {
      event.currentTarget.select()
    },
    // 标记当前子页面的移动端页面是否是pc端对应的移动度样式
    markMobileSubPageStyleToPc() {
      sessionStorage.setItem("mobileSubPageStyleToPc", true) // 标记当前子页面的移动端页面
      this.$message({
        customClass: "bigScreen_msg_backGroud",
        duration: 3000,
        type: "success",
        message: "标记成功"
      })
    },
    changeMangerType() {
      this.managerType = this.managerType === 1 ? 0 : 1
    },
    // 接口返回状态码判断，是否是最新的版本
    isLatestVersion(data) {
      return !["mh_portal_50070", "mh_portal_50071"].includes(data)
    },
    // 保存和预览时批量处理分页
    updatePageSize(appIdList) {
      let pageSizeList = sessionStorage.getItem("pageSizeList") || "[]"
      pageSizeList = pageSizeList && JSON.parse(pageSizeList)
      console.log("appIdList :>>", appIdList, pageSizeList)
      let tempAppIdList = appIdList || []
      pageSizeList.forEach((item, index) => {
        if (tempAppIdList.indexOf(item.appId) === -1) {
          // 排除掉页面上不存在的应用
          pageSizeList.splice(index, 1)
        }
      })
      pageSizeList?.length > 0 && this.$API.updateAppPageAttrBatch(pageSizeList)
      sessionStorage.setItem("pageSizeList", "[]") //清空
    },
    changeSubPageTemplate() {
      // 通知父页面保存
      window.opener.postMessage({
        type: "updateSubPageSettingMapping",
        data: { appId: this.urlParams.appId, prefix: this.request_prefix }
      })
      sessionStorage.setItem("changingSubPageTemplate", "1")
      if (this.request_prefix === "stage") {
        initPcStageData(this.urlParams.appId, this.urlParams, true)
      } else {
        initAppStageData(this.urlParams.appId, this.urlParams)
      }
    },
    // 子页面通知父级页面更新
    updateSubPageSettingMapping({ data }) {
      if (data.type === "updateSubPageSettingMapping") {
        const { appId, prefix } = data.data
        // 更新子页面映射关系
        let subPages = JSON.parse(JSON.stringify(this.$store.state[this.request_prefix].page?.subPages))
        // 根据appId过滤掉之前的数据
        subPages = subPages.filter(item => item.appId !== appId)
        const subPage = JSON.parse(localStorage.getItem("subPageSetting-" + appId + "-" + prefix))
        if (subPage) {
          subPages.push(subPage)
        }
        updateSubPageMapping.call(this, subPages, appId, prefix)
        this.save()
      }
    },
    // 更新子页面预览地址
    updateSubPageUrl(oldSubPageId, subPageId, engineInstanceId, homePageId) {
      const params = {
        templateSubPageId: oldSubPageId,
        subPageId: subPageId,
        engineInstanceId: engineInstanceId,
        pageId: homePageId
      }
      this.$API.updateSubPageLink(params).then(res => {
        console.log("updateSubPageLink", res)
      })
    },
    editSubpage: _throttle(async function () {
      const { pv, appId, pageId, engineInstanceId, homePageId } = this.urlParams
      const pageType = pv === "1" ? "listPage" : "detailPage"
      const subPageSettings = window.localStorage.getItem("subPageSetting-" + appId + "-" + this.request_prefix)
      const subPage = subPageSettings ? JSON.parse(subPageSettings) : null
      if (!subPage) {
        return
      }
      const templateId = pv === "1" ? subPage.listPageTemplateId : subPage.detailPageTemplateId
      const oldSubPageId = pv === "1" ? subPage.listPageId : subPage.detailPageId
      this.isEditStatus = true
      if (this.request_prefix === "stage") {
        // 生成预览子页面pageId
        generateSubPageIdHandle.call(this, pageType, appId).then(pageId => {
          generateSubPageHandle.call(this, pageId, pageType, templateId).then(res => {
            this.isEditStatus = false
            subPage[`${pageType}Id`] = pageId
            subPage[`${pageType}IsUseSystemTemplate`] = false
            localStorage.setItem("subPageSetting-" + appId + "-" + this.request_prefix, JSON.stringify(subPage))
            window.opener.postMessage({
              type: "updateSubPageSettingMapping",
              data: { appId, prefix: this.request_prefix }
            })
            sessionStorage.setItem("isJumpingSubPage", true)
            // 需要删除pv相关参数
            let newUrl = replaceUrlParam(window.location.href, "p", pageId)
            newUrl = newUrl.replace(/&pv=[^&]*/, "")
            window.location.href = newUrl

            this.updateSubPageUrl(oldSubPageId, subPage[`${pageType}Id`], engineInstanceId, homePageId)
          })
        })
      } else if (this.request_prefix === "appStage") {
        // 生成预览子页面pageId
        generateSubPageIdHandle.call(this, pageType, appId).then(pageId => {
          generateSubPageHandle.call(this, pageId, pageType, templateId).then(res => {
            this.isEditStatus = false
            subPage[`${pageType}Id`] = pageId
            subPage[`${pageType}IsUseSystemTemplate`] = false
            localStorage.setItem("subPageSetting-" + appId + "-" + this.request_prefix, JSON.stringify(subPage))
            window.opener.postMessage({
              type: "updateSubPageSettingMapping",
              data: { appId, prefix: this.request_prefix }
            })
            sessionStorage.setItem("isJumpingSubPage", true)
            // 需要删除pv相关参数
            let newUrl = replaceUrlParam(window.location.href, "p", pageId)
            newUrl = newUrl.replace(/&pv=[^&]*/, "")
            window.location.href = newUrl

            this.updateSubPageUrl(oldSubPageId, subPage[`${pageType}Id`], engineInstanceId, homePageId)
          })
        })
      } else {
        // 需要删除pv相关参数
        let newUrl = replaceUrlParam(window.location.href, "p", pageId)
        newUrl = newUrl.replace(/&pv=[^&]*/, "")
        window.location.href = newUrl
      }
    }, 3000),
    lockingFunc() {
      let messageTxt = "锁定后，该页面将不能被其他管理员编辑，系统只会保存你提交的更改。"
      if (this.lockingChecked) {
        messageTxt = "解除锁定后，其他管理员可编辑页面，请确认编辑已保存。"
      }
      this.$confirm(messageTxt, "", {
        confirmButtonText: this.lockingChecked ? "解锁" : "锁定",
        cancelButtonText: "取消",
        type: "warning",
        showClose: false,
        iconClass: "bigScreen_confirm_icon el-icon-warning",
        cancelButtonClass: "bigScreen_confirm_cancel_button",
        confirmButtonClass: "bigScreen_confirm_button",
        customClass: "bigScreen_confirm custom_warning_dialog"
      }).then(() => {
        this.$message({
          type: "success",
          message: this.lockingChecked ? "解锁成功" : "页面已锁定"
        })
        this.lockingChecked = !this.lockingChecked
      })
    },
    // 放大缩放下拉框更多操作
    topOperationSetting1(type) {
      if (type === 1) {
        // this.showAllComponent = !this.showAllComponent
        // this.setToolCheckList("professional")
      } else if (type === 2) {
        this.showComponentName = !this.showComponentName
        this.setToolCheckList("comptName")
      } else if (type === 3) {
        this.showRuler = !this.showRuler
        this.setToolCheckList("ruler")
      } else if (type === 4) {
        this.showAllScreen = !this.showAllScreen
        this.setToolCheckList("width")
      }
    },
    zoomPopShowFunc() {
      this.zoomPopShow = true
    },
    zoomPopHideFunc() {
      this.zoomPopShow = false
    },
    //  点击缩放弹窗区域外关闭弹框
    togglePopover() {
      this.zoomPopShow = !this.zoomPopShow
      if (this.zoomPopShow) {
        this.$nextTick(() => {
          //输入框获取焦点
          let singleInput = this.$refs.elZoomInput.$el
          singleInput.getElementsByTagName("input")[0].focus()
          // 添加全局点击事件监听
          document.addEventListener("click", this.handleDocumentClick, true)
        })
      }
    },
    handleDocumentClick(e) {
      const popover = this.$refs.zoomBoxPopover
      const popover1 = this.$refs.zoomBoxPopover1
      if (!popover || popover1.contains(e.target)) {
        return
      }
      setTimeout(() => {
        this.zoomPopShow = false
        // 移除全局点击事件监听
        document.removeEventListener("click", this.handleDocumentClick, true)
      }, 300)
    },
    initPlugins() {
      let pluginName = this.$store.state[this.request_prefix].page.pluginName
      if (
        this.$store.state[this.request_prefix].type === "detailPage" ||
        this.$store.state[this.request_prefix].type === "listPage"
      ) {
        const plugins = [...pluginName].filter(it => it.trim().length)
        plugins.forEach(item => {
          if (hasProperty(this, item) && typeof this[item] === "function") {
            this[item]()
          }
        })
      }
    },
    dropdownMenuVisible(e) {
      this.menuShow = e
    }
  },
  destroyed() {
    clearTimeout(this.autoSaveTimer)
    document.removeEventListener("visibilitychange", this.visibilityStateChange)
    window.removeEventListener("message", this.updateSubPageSettingMapping)
  }
}
</script>
